import React from "react";

const EditIcon = ({width = "18px", height = "18px", color}) => {
    return (<svg
        fill={color ? color : "#6e86c4"}
        viewBox="0 0 26 26"
        width={`${width}`}
        height={`${height}`}
    >
        <path
            fill="none"
            stroke={color ? color : "#6e86c4"}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit={10}
            strokeWidth="1.95"
            d="M8.938 22.608L1.088 24.912 3.392 17.063"
        />
        <path
            d="M1.894 21.158l-.86 2.931c-.072.249-.004.517.178.7.135.134.316.207.5.207.067 0 .135-.01.2-.029l2.931-.86L1.894 21.158zM5.175 18.832L6.772 19.19 7.002 20.658 17.996 9.674 16.17 7.846zM19.202 10.857L8.123 21.926 9.546 23.35 20.669 12.324zM15.085 6.739L13.774 5.43 2.652 16.454 4.006 17.808zM21.666 11.229L14.771 4.334 16.349 2.855 23.243 9.75zM24.061 8.548l-6.607-6.608 1.014-1.025c.902-.902 2.373-.895 3.285.018l3.305 3.304c.912.913.92 2.384.018 3.286L24.061 8.548z"/>
    </svg>);
};

const SendIcon = ({width = "18", height = "18", color}) => {
    return (<svg
        viewBox="0 0 512 512"
        width={`${width}`}
        height={`${height}`}
        fill={color ? color : "#6e86c4"}
    >
        <g data-name="1" id="_1">
            <path
                d="M291.48,449.94A15,15,0,0,1,278,441.5L207.5,296.57,62.57,226.08a15,15,0,0,1,1-27.41L435.48,49.08A15,15,0,0,1,455,68.6L305.4,440.54A15,15,0,0,1,292,449.93Zm-185.38-236,119.18,58a15,15,0,0,1,6.93,6.93l58,119.18L414,90Z"/>
            <path
                d="M218.72,300.35a15,15,0,0,1-10.6-25.61L430.47,52.39a15,15,0,1,1,21.21,21.22L229.33,296A15,15,0,0,1,218.72,300.35Z"/>
        </g>
    </svg>);
};

const SettingSystemIcon = ({width = "18", height = "18", color}) => {
    return (<svg
        enableBackground="new 0 0 128 128"
        height={`${height}px`}
        id="Layer_1"
        version="1.1"
        viewBox="0 0 128 128"
        width={`${width}px`}
    >
        <g id="settings">
            <path
                d="M53.894,24.5c-16.351,0-29.606,13.255-29.606,29.606c0,16.351,13.255,29.606,29.606,29.606   c16.351,0,29.606-13.255,29.606-29.606C83.5,37.755,70.245,24.5,53.894,24.5z M53.894,69.39c-8.441,0-15.283-6.843-15.283-15.283   s6.842-15.283,15.283-15.283s15.283,6.842,15.283,15.283S62.334,69.39,53.894,69.39z"
                fill="#D0D0D0"
            />
            <path
                d="M53.894,32.367c-12.006,0-21.739,9.733-21.739,21.739c0,12.006,9.733,21.739,21.739,21.739   c12.006,0,21.739-9.733,21.739-21.739C75.633,42.1,65.9,32.367,53.894,32.367z M53.894,69.39c-8.441,0-15.283-6.843-15.283-15.283   s6.842-15.283,15.283-15.283s15.283,6.842,15.283,15.283S62.334,69.39,53.894,69.39z"
                fill="#989898"
            />
            <path
                d="M93.641,46h-4.905c-0.855-3-2.214-6.997-3.999-10.002l3.433-3.547c2.826-2.826,2.826-7.507,0-10.333   l-1.927-1.955c-2.826-2.826-7.45-2.84-10.276-0.014l-3.2,3.314C69.739,21.588,66,20.139,63,19.223v-4.559   C63,10.65,59.505,9,55.492,9h-2.725C48.754,9,45,10.65,45,14.664v4.346c-3,0.846-6.844,2.242-9.979,4.103l-2.854-2.979   c-2.826-2.826-7.388-2.826-10.214,0l-1.896,1.927c-2.826,2.826-2.81,7.45,0.016,10.276l2.875,3.094   C20.995,38.588,19.524,43,18.615,46h-3.997C10.622,46,7,48.816,7,52.812v2.725C7,59.534,10.622,64,14.618,64h3.997   c0.909,2.862,2.387,6.587,4.341,9.743l-2.867,2.568c-2.826,2.826-2.826,7.301,0,10.127l1.927,1.852   c2.826,2.826,7.45,2.789,10.276-0.037l2.728-2.997C38.156,87.117,42,88.494,45,89.34v4.346c0,4.013,3.754,8.314,7.767,8.314h2.725   C59.505,102,63,97.699,63,93.686v-4.559c3-0.916,6.739-2.359,9.767-4.233l3.26,3.321c2.826,2.826,7.42,2.826,10.246,0l1.912-1.927   c2.826-2.826,2.818-7.45-0.008-10.276l-3.437-2.835c1.784-3.005,3.14-6.315,3.995-9.177h4.905c3.997,0,6.359-4.466,6.359-8.463   v-2.725C100,48.816,97.638,46,93.641,46z M53.894,79.656c-14.11,0-25.549-11.439-25.549-25.549s11.439-25.549,25.549-25.549   s25.549,11.439,25.549,25.549S68.004,79.656,53.894,79.656z"
                fill="#989898"
            />
            <path
                d="M52.768,98C51.077,98,49,95.621,49,93.687v-7.375l-2.915-0.821c-2.015-0.568-5.865-1.801-9.022-3.675   l-2.806-1.665l-4.847,5.327c-0.617,0.59-1.429,0.913-2.293,0.913c-0.866,0-1.673-0.33-2.271-0.929l-1.985-1.908   c-1.176-1.178-1.195-3.095-0.005-4.351l5.266-4.717l-1.764-2.849c-2-3.229-3.32-6.93-3.93-8.849L21.542,60h-6.924   C13.029,60,11,57.497,11,55.537v-2.725C11,51.075,12.878,50,14.618,50h6.965l0.86-2.84c0.486-1.605,1.968-6.492,3.906-9.623   l1.605-2.594l-5.053-5.434c-1.278-1.278-1.285-3.351-0.016-4.62l1.918-1.949c0.588-0.589,1.397-0.925,2.256-0.925   c0.857,0,1.667,0.336,2.277,0.947l4.992,5.212l2.732-1.622c2.34-1.389,5.63-2.735,9.024-3.693L49,22.037v-7.373   C49,13.047,52.382,13,52.768,13h2.725C57.093,13,59,13.289,59,14.664v7.519l2.831,0.865c3.345,1.022,6.563,2.414,8.831,3.816   l2.742,1.697l5.44-5.635c0.557-0.556,1.372-0.891,2.246-0.891c0.883,0,1.708,0.34,2.324,0.955l1.906,1.935   c1.287,1.288,1.287,3.43,0.021,4.697l-5.604,5.789l1.561,2.628c1.253,2.111,2.528,5.327,3.591,9.056L85.716,50h7.925   C94.347,50,96,50,96,52.812v2.725C96,57.748,94.81,60,93.641,60h-7.886l-0.853,2.855c-0.857,2.872-2.136,5.812-3.601,8.279   l-1.75,2.946l5.904,4.871c1.168,1.281,1.136,3.272-0.1,4.508l-1.923,1.938c-0.6,0.6-1.415,0.937-2.283,0.937   s-1.684-0.337-2.295-0.948l-5.476-5.576l-2.718,1.683c-3.087,1.91-6.857,3.206-8.83,3.809L59,86.166v7.521   C59,95.662,57.099,98,55.492,98H52.768z M53.894,24.558c-16.293,0-29.549,13.256-29.549,29.549c0,16.294,13.256,29.55,29.549,29.55   c16.294,0,29.55-13.256,29.55-29.55C83.443,37.813,70.187,24.558,53.894,24.558z"
                opacity="0.1"
            />
            <path
                d="M76.027,88.215c1.892,1.892,4.575,2.51,6.991,1.869c-0.02-0.253-0.039-0.506-0.039-0.764   c0-4.496,3.064-8.281,7.21-9.403c-0.245-1.433-0.912-2.806-2.012-3.906l-3.437-2.835c1.784-3.005,3.14-6.315,3.995-9.177h4.905   c2.9,0,4.933-2.354,5.834-5.171C98.157,57.135,96.127,56,93.934,56h-1.806C88.331,56,85,59.331,85,63.128v1.399   c-1.217,0.397-2.737,0.967-4.24,1.717l-0.869-0.904c-0.682-0.683-1.486-1.196-2.359-1.533c-1.921,4.676-5.185,8.658-9.317,11.46   c0.223,0.324,0.473,0.634,0.759,0.921l0.943,1.04c-0.782,1.551-1.413,3.274-1.9,4.772h-1.179C62.939,82,60,84.759,60,88.417v1.807   c0,2.128,0.987,4.397,2.576,5.933c0.27-0.81,0.424-1.645,0.424-2.47v-4.559c3-0.916,6.739-2.359,9.767-4.233L76.027,88.215z"
                opacity="0.2"
            />
            <path
                d="M119.224,84h-3.252c-0.567-2-1.468-4.688-2.651-6.68l2.276-2.376c1.873-1.873,1.873-4.989,0-6.862   l-1.277-1.302c-1.873-1.873-4.939-1.886-6.812-0.012l-2.077,2.195C103.423,67.72,100,66.757,99,66.15v-3.022   C99,60.467,96.594,58,93.934,58h-1.806C89.467,58,87,60.467,87,63.128v2.881c-2,0.561-4.548,1.486-6.626,2.72l-1.897-1.975   c-1.873-1.873-4.9-1.873-6.774,0l-1.258,1.277c-1.873,1.873-1.864,4.939,0.01,6.812l1.905,2.1C71.065,79.037,70.09,82,69.488,84   h-2.65C64.188,84,62,85.768,62,88.417v1.806C62,92.873,64.188,96,66.838,96h2.65c0.603,1,1.582,4.283,2.877,6.376l-1.9,1.661   c-1.873,1.873-1.873,4.819,0,6.692l1.277,1.217c1.873,1.873,4.939,1.843,6.812-0.03l1.819-1.99   c2.078,1.234,4.626,2.144,6.626,2.705v2.881c0,2.66,2.467,5.487,5.128,5.487h1.806c2.66,0,5.066-2.826,5.066-5.487v-3.022   c1-0.608,4.423-1.564,6.43-2.806l2.139,2.201c1.873,1.873,4.908,1.873,6.781,0l1.262-1.277c1.873-1.873,1.866-4.939-0.008-6.812   l-2.28-1.796c1.183-1.992,2.08-5.001,2.647-6.001h3.252c2.649,0,4.776-3.127,4.776-5.776v-1.806C124,85.768,121.873,84,119.224,84z    M92.73,101.07c-6.489,0-11.75-5.261-11.75-11.75c0-6.489,5.261-11.75,11.75-11.75s11.75,5.261,11.75,11.75   C104.479,95.81,99.219,101.07,92.73,101.07z"
                fill={color ? color : "#6E86C4"}
            />
            <path
                d="M92.128,117c-0.396-0.062-1.128-0.932-1.128-1.486v-5.915l-2.921-0.818   c-2.169-0.608-4.233-1.443-5.662-2.293l-2.798-1.661l-3.932,4.298c-0.208,0.184-0.442,0.212-0.569,0.212   c-0.149,0-0.367-0.037-0.548-0.218l-1.347-1.285c-0.086-0.087-0.164-0.262-0.164-0.45c0-0.164,0.06-0.317,0.177-0.457l4.315-3.77   l-1.785-2.885c-0.589-0.951-1.182-2.457-1.658-3.666c-0.437-1.108-0.781-1.983-1.195-2.67L71.747,92h-4.798   C66.578,91.793,66,90.896,66,90.224v-1.807C66,88.005,66.804,88,66.838,88h5.622l0.857-2.846c0.312-1.039,1.265-4.198,2.444-6.105   l1.585-2.561l-3.994-4.404l-0.069-0.068c-0.315-0.316-0.319-0.846-0.009-1.156l1.279-1.299c0.171-0.171,0.388-0.212,0.536-0.212   s0.365,0.041,0.559,0.233l4.039,4.207l2.73-1.62c1.461-0.868,3.524-1.709,5.662-2.309L91,69.042v-5.914   C91,62.675,91.675,62,92.128,62h1.806C94.339,62,95,62.63,95,63.128V68.4l1.924,1.169c0.724,0.439,1.654,0.792,2.833,1.237   c1.206,0.456,2.708,1.024,3.567,1.557l2.771,1.715l4.263-4.505c0.183-0.169,0.395-0.205,0.543-0.205   c0.131,0,0.381,0.031,0.59,0.239l1.249,1.275c0.338,0.337,0.337,0.924,0.027,1.233l-4.438,4.633l1.552,2.613   c0.764,1.286,1.56,3.32,2.241,5.728l0.824,2.91h6.276c0.29,0,0.776,0.054,0.776,0.417v1.807c0,0.679-0.538,1.558-0.898,1.776   h-5.461l-1.149,2.028c-0.368,0.651-0.682,1.458-1.078,2.479c-0.438,1.13-0.984,2.536-1.527,3.451l-1.789,3.015l4.768,3.757   c0.225,0.318,0.198,0.772-0.081,1.051l-1.278,1.295c-0.176,0.175-0.395,0.216-0.545,0.216s-0.369-0.041-0.562-0.233l-4.34-4.468   l-2.734,1.693c-0.858,0.531-2.358,1.098-3.564,1.552c-1.179,0.444-2.11,0.796-2.835,1.236L95,110.241v5.272   c0,0.596-0.71,1.414-1.082,1.486H92.128z M92.729,73.57c-8.685,0-15.75,7.065-15.75,15.75s7.065,15.75,15.75,15.75   s15.75-7.065,15.75-15.75S101.414,73.57,92.729,73.57z"
                fill={color ? color : "#6E86C4"}
                opacity="0.1"
            />
        </g>
    </svg>);
};

const DigitalPen = ({width = "18px", height = "18px", stroke = "#000000"}) => {
    return (<svg
        width={`${width}`}
        height={`${height}`}
        viewBox="0 0 14 14"
        version="1.1"
        stroke={stroke}
    >
        <g
            id="Version-2"
            strokeWidth="1"
            fill={"none"}
            fillRule={"evenodd"}
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <g
                id="Admin-Dashboard---messages-and-submitted-forms"
                transform="translate(-977.000000, -409.000000)"
                strokeWidth="0.75"
            >
                <g id="Group-8" transform="translate(736.000000, 340.000000)">
                    <g id="Group-3" transform="translate(105.000000, 67.000000)">
                        <g id="Group-9" transform="translate(137.000000, 3.000000)">
                            <path
                                d="M1.24189103,8.49755436 C1.93323003,7.80071999 3.05426688,7.78274554 3.76759047,8.45705791 C4.44113092,9.17114575 4.4218944,10.2921975 3.72425217,10.9827571 C3.04007536,11.6662235 0.00213139193,12.2225168 0.00213139193,12.2225168 C0.00213139193,12.2225168 0.556293294,9.18315188 1.24189103,8.49755436 Z"
                                id="Stroke-4"
                            ></path>
                            <line
                                x1="2.00990259"
                                y1="10.2126142"
                                x2="0"
                                y2="12.2218063"
                                id="Stroke-5"
                            ></line>
                            <path
                                d="M5.27661596,8.95438248 C4.99918048,9.23173483 4.54945608,9.23173483 4.27201989,8.95438248 L3.27026604,7.94978642 C2.99291371,7.67235024 2.99291371,7.22262654 3.27026604,6.94519036 L6.78493098,3.43052506 L8.79483357,5.43971719 L5.27661596,8.95438248 Z"
                                id="Stroke-6"
                            ></path>
                            <path
                                d="M9.79658778,0.416028469 C9.24171541,-0.138676156 8.34226802,-0.138676156 7.78739565,0.416028469 L3.76759047,4.43441279"
                                id="Stroke-7"
                            ></path>
                            <path
                                d="M9.79658778,0.416027474 C10.3516072,-0.138795585 11.2513118,-0.138636512 11.8061351,0.416382777 C12.3609585,0.971401783 12.3607993,1.87110708 11.8057799,2.42593042 L8.79199171,5.43971861 L6.78208912,3.43052648 L9.79658778,0.416027474 Z"
                                id="Stroke-8"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>);
};

const CrossIcon = ({width = "15", height = "17"}) => {
    return (<svg width={`${width}px`} height={`${height}px`} viewBox="0 0 18 18">
        <path
            d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"/>
    </svg>);
};

const HistoryIcon = ({color, width}) => {
    return (<svg
        width={width}
        fill={color ? color : "#6e86c4"}
        id="OutlineExpand"
        version="1.1"
        viewBox="0 0 64 64"
    >
        <path
            fill={color ? color : "#6e86c4"}
            d="M61.383,2.076c-0.373-0.154-0.804-0.07-1.09,0.217L50,12.586V5c0-0.552-0.447-1-1-1H8c-3.309,0-6,2.691-6,6v46  c0,3.309,2.691,6,6,6h41c0.553,0,1-0.448,1-1V33.414l4.678-4.678c4.722-4.722,7.322-11,7.322-17.677V3  C62,2.596,61.757,2.231,61.383,2.076z M48,60H8c-2.206,0-4-1.794-4-4s1.794-4,4-4h40V60z M48,50H8c-1.538,0-2.937,0.586-4,1.54V10  c0-2.206,1.794-4,4-4h40v8.586L34.293,28.293C34.105,28.48,34,28.735,34,29v8.586l-5.707,5.707l1.414,1.414L35.414,39H44  c0.266,0,0.52-0.105,0.707-0.293L48,35.414V50z M60,11.059c0,6.144-2.393,11.919-6.736,16.263L43.586,37h-6.172l16.293-16.293  l-1.414-1.414L36,35.586v-6.172l24-24V11.059z"
        />
        <path
            fill={color ? color : "#6e86c4"}
            d="M26,29c5.514,0,10-4.486,10-10S31.514,9,26,9s-10,4.486-10,10S20.486,29,26,29z M21.081,25.296  C21.427,22.857,23.491,21,26,21s4.573,1.857,4.919,4.296C29.56,26.36,27.855,27,26,27S22.44,26.36,21.081,25.296z M24,17  c0-1.103,0.897-2,2-2s2,0.897,2,2s-0.897,2-2,2S24,18.103,24,17z M26,11c4.411,0,8,3.589,8,8c0,1.699-0.536,3.273-1.443,4.57  c-0.639-1.734-1.942-3.132-3.595-3.906C29.6,18.955,30,18.027,30,17c0-2.206-1.794-4-4-4s-4,1.794-4,4  c0,1.027,0.4,1.955,1.038,2.664c-1.653,0.774-2.956,2.172-3.595,3.906C18.536,22.273,18,20.699,18,19C18,14.589,21.589,11,26,11z"
        />
        <rect height="2" width="10" x="17" y="43"/>
        <rect height="2" width="13" x="17" y="38"/>
        <rect height="2" width="15" x="17" y="33"/>
    </svg>);
};

const HomeIcon = ({width = "24", height = "24", color}) => {
    return (<svg
        width={`${width}px`}
        height={`${height}px`}
        color={color ? color : "#6e86c4"}
        fillRule="evenodd"
        clipRule="evenodd"
    >
        <path
            d="M22 11.414v12.586h-20v-12.586l-1.293 1.293-.707-.707 12-12 12 12-.707.707-1.293-1.293zm-6 11.586h5v-12.586l-9-9-9 9v12.586h5v-9h8v9zm-1-7.889h-6v7.778h6v-7.778z"
            fill={color ? color : "#6e86c4"}
        />
    </svg>);
};

const RefreshIcon = ({width = "16", height = "16", color}) => {
    return (<svg width={`${width}px`} height={`${height}px`} viewBox="0 0 24 24">
        <path
            fill={color ? color : "#6e86c4"}
            d="M13.5 2c-5.629 0-10.212 4.436-10.475 10h-3.025l4.537 5.917 4.463-5.917h-2.975c.26-3.902 3.508-7 7.475-7 4.136 0 7.5 3.364 7.5 7.5s-3.364 7.5-7.5 7.5c-2.381 0-4.502-1.119-5.876-2.854l-1.847 2.449c1.919 2.088 4.664 3.405 7.723 3.405 5.798 0 10.5-4.702 10.5-10.5s-4.702-10.5-10.5-10.5z"
        />
    </svg>);
};

const HorizontalArrow = ({
                             width = "15", height = "19", color = "#A7A7A7",
                         }) => {
    return (<svg
        width={`${width}px`}
        height={`${height}px`}
        viewBox="0 0 24 24"
        className="horizontal-arrow"
    >
        <path
            d="M13.025 1l-2.847 2.828 6.176 6.176h-16.354v3.992h16.354l-6.176 6.176 2.847 2.828 10.975-11z"
            fill={`${color}`}
        />
    </svg>);
};

const AdminSettingIcon = ({width = "24", height = "24", color}) => {
    return (<svg width={`${width}px`} height={`${height}px`} viewBox="0 0 24 24">
        <path
            d="M17 10.645v-2.29c-1.17-.417-1.907-.533-2.28-1.431-.373-.9.07-1.512.6-2.625l-1.618-1.619c-1.105.525-1.723.974-2.626.6-.9-.373-1.017-1.116-1.431-2.28h-2.29c-.412 1.158-.53 1.907-1.431 2.28h-.001c-.9.374-1.51-.07-2.625-.6l-1.617 1.619c.527 1.11.973 1.724.6 2.625-.375.901-1.123 1.019-2.281 1.431v2.289c1.155.412 1.907.531 2.28 1.431.376.908-.081 1.534-.6 2.625l1.618 1.619c1.107-.525 1.724-.974 2.625-.6h.001c.9.373 1.018 1.118 1.431 2.28h2.289c.412-1.158.53-1.905 1.437-2.282h.001c.894-.372 1.501.071 2.619.602l1.618-1.619c-.525-1.107-.974-1.723-.601-2.625.374-.899 1.126-1.019 2.282-1.43zm-8.5 1.689c-1.564 0-2.833-1.269-2.833-2.834s1.269-2.834 2.833-2.834 2.833 1.269 2.833 2.834-1.269 2.834-2.833 2.834zm15.5 4.205v-1.077c-.55-.196-.897-.251-1.073-.673-.176-.424.033-.711.282-1.236l-.762-.762c-.52.248-.811.458-1.235.283-.424-.175-.479-.525-.674-1.073h-1.076c-.194.545-.25.897-.674 1.073-.424.176-.711-.033-1.235-.283l-.762.762c.248.523.458.812.282 1.236-.176.424-.528.479-1.073.673v1.077c.544.193.897.25 1.073.673.177.427-.038.722-.282 1.236l.762.762c.521-.248.812-.458 1.235-.283.424.175.479.526.674 1.073h1.076c.194-.545.25-.897.676-1.074h.001c.421-.175.706.034 1.232.284l.762-.762c-.247-.521-.458-.812-.282-1.235s.529-.481 1.073-.674zm-4 .794c-.736 0-1.333-.597-1.333-1.333s.597-1.333 1.333-1.333 1.333.597 1.333 1.333-.597 1.333-1.333 1.333zm-4 3.071v-.808c-.412-.147-.673-.188-.805-.505s.024-.533.212-.927l-.572-.571c-.389.186-.607.344-.926.212s-.359-.394-.506-.805h-.807c-.146.409-.188.673-.506.805-.317.132-.533-.024-.926-.212l-.572.571c.187.393.344.609.212.927-.132.318-.396.359-.805.505v.808c.408.145.673.188.805.505.133.32-.028.542-.212.927l.572.571c.39-.186.608-.344.926-.212.318.132.359.395.506.805h.807c.146-.409.188-.673.507-.805h.001c.315-.131.529.025.924.213l.572-.571c-.186-.391-.344-.609-.212-.927s.397-.361.805-.506zm-3 .596c-.552 0-1-.447-1-1s.448-1 1-1 1 .447 1 1-.448 1-1 1z"
            fill={color ? color : "#6e86c4"}
        />
    </svg>);
};

const DownArrowIcon = () => {
    return (<svg version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 612 612">
        <g>
            <g id="_x31_0_34_">
                <g>
                    <path
                        d="M604.501,134.782c-9.999-10.05-26.222-10.05-36.221,0L306.014,422.558L43.721,134.782
  				c-9.999-10.05-26.223-10.05-36.222,0s-9.999,26.35,0,36.399l279.103,306.241c5.331,5.357,12.422,7.652,19.386,7.296
  			c6.988,0.356,14.055-1.939,19.386-7.296l279.128-306.268C614.5,161.106,614.5,144.832,604.501,134.782z"
                    />
                </g>
            </g>
        </g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
    </svg>);
};

const TransactionReportIcon = ({width = "24", height = "24", color}) => {
    return (<svg
        enableBackground="new -1 -1 26 26"
        id="Layer_1"
        version="1.1"
        width={`${width}px`}
        height={`${height}px`}
        color={color ? color : "#6e86c4"}
        viewBox="-1 -1 26 26"
    >
        <g>
            <path
                fill={color ? color : "#6e86c4"}
                d="M22-1H7.8C6.1-1,5,0.3,5,2v0.8L1.1,4.2c-1.6,0.6-2.4,2.3-1.9,3.9L4.6,23c0.3,0.8,0.8,1.4,1.6,1.7C6.5,24.9,7,25,7.4,25   s0.7-0.2,1-0.3l9.7-3.7H22c1.7,0,3-1.1,3-2.8V2C25,0.3,23.7-1,22-1z M1.2,7.4C1,6.9,1.3,6.3,1.8,6.1L5,5v12.8L1.2,7.4z M7.8,22.8   c-0.3,0.1-0.5,0.1-0.8,0c-0.2-0.1-0.4-0.3-0.5-0.5l-0.7-2C6.3,20.8,7,21,7.8,21h4.6L7.8,22.8z M23,18c0,0.6-0.4,1-1,1H8   c-0.6,0-1-0.4-1-1V2c0-0.6,0.4-1,1-1h14c0.6,0,1,0.4,1,1V18z"
            />
            <path
                fill={color ? color : "#6e86c4"}
                d="M10,9c0,0.3,0.2,0.5,0.5,0.5S11,9.3,11,9V8.3c0.2-0.1,0.4-0.1,0.6-0.3C11.9,7.8,12,7.4,12,7s-0.1-0.6-0.3-0.8   s-0.5-0.4-1-0.6c0,0,0,0-0.1,0C10.2,5.5,10,5.3,10,5.1c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1s0.2,0,0.3,0.1   c0.2,0,0.3,0.1,0.4,0.2l0.8-0.4c-0.1-0.3-0.3-0.5-0.6-0.6c-0.1,0-0.2,0-0.3,0V3c0-0.3-0.2-0.5-0.5-0.5S10,2.7,10,3v0.9   C9.8,4,9.5,4.1,9.4,4.2C9.1,4.5,9,4.8,9,5.1c0,0.4,0,0.6,0.2,0.8c0.2,0.2,0.5,0.4,1,0.6c0.1,0,0.1,0.1,0.2,0.1   C10.8,6.7,11,6.9,11,7.1c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1l0,0h-0.1c-0.1,0-0.3,0-0.4-0.1c-0.2,0-0.3-0.1-0.4-0.3   L8.9,7.6C9,7.8,9.2,8,9.5,8.2c0.1,0,0.3,0.1,0.5,0.1V9z"
            />
            <path
                fill={color ? color : "#6e86c4"}
                d="M20,3h-5c-0.3,0-0.5,0.2-0.5,0.5S14.7,4,15,4h5c0.3,0,0.5-0.2,0.5-0.5S20.3,3,20,3z"
            />
            <path
                fill={color ? color : "#6e86c4"}
                d="M20,6h-5c-0.3,0-0.5,0.2-0.5,0.5S14.7,7,15,7h5c0.3,0,0.5-0.2,0.5-0.5S20.3,6,20,6z"
            />
            <path
                fill={color ? color : "#6e86c4"}
                d="M20,9h-5c-0.3,0-0.5,0.2-0.5,0.5S14.7,10,15,10h5c0.3,0,0.5-0.2,0.5-0.5S20.3,9,20,9z"
            />
            <path
                fill={color ? color : "#6e86c4"}
                d="M20,12H10c-0.3,0-0.5,0.2-0.5,0.5S9.7,13,10,13h10c0.3,0,0.5-0.2,0.5-0.5S20.3,12,20,12z"
            />
            <path
                fill={color ? color : "#6e86c4"}
                d="M20,15H10c-0.3,0-0.5,0.2-0.5,0.5S9.7,16,10,16h10c0.3,0,0.5-0.2,0.5-0.5S20.3,15,20,15z"
            />
        </g>
    </svg>);
};

const HhaCardIcon = ({width = "24", height = "29"}) => {
    return (<svg
        width={`${width}px`}
        height={`${height}px`}
        viewBox="0 0 24 29"
        version="1.1"
    >
        <g
            id="Page-1"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <g
                id="payments---eCheck"
                transform="translate(-1051.000000, -352.000000)"
                fill="#232323"
            >
                <g id="hha-icon" transform="translate(1051.000000, 352.000000)">
                    <path
                        d="M23.8624854,19.5592991 C23.6494589,19.609423 22.5970695,19.9978832 21.9456713,19.6470159 C20.3417067,18.7949097 20.0532819,18.8575646 19.727689,18.7825912 C19.3768217,18.6948743 18.7254235,18.6445381 17.5099191,19.0455292 C16.2944146,19.4339894 16.3320076,18.9079009 16.3320076,18.9079009 C16.3320076,18.7825912 16.3946624,18.3064142 16.1816359,18.3064142 C15.8057067,18.2938832 15.9813527,18.0182018 15.9813527,18.0182018 L15.9560784,17.9555469 C15.667866,17.905423 15.830981,17.6548035 15.830981,17.6548035 C15.7683261,17.2162195 15.6179545,17.4043965 15.4172465,17.2663434 C15.2167509,17.1410336 15.1543084,16.9154761 15.3295297,16.7149805 C15.8057067,16.188892 15.5552996,15.7753699 15.5552996,15.7753699 C15.1415651,13.6701664 19.4896005,12.3671575 21.0557598,10.8007858 C22.6221314,9.23462655 20.8554766,7.94414867 20.8554766,7.94414867 C20.8554766,7.94414867 20.9931049,9.38499823 19.1637952,10.3872637 C17.3344854,11.3897416 15.7430518,12.630308 15.3295297,12.8182726 C15.0039368,12.9686442 14.2520784,13.7954761 14.2520784,14.2591221 C14.2520784,14.2591221 13.9012111,15.4746265 13.9889279,15.6876531 C14.0766447,15.9129982 14.1643615,16.1761487 13.9889279,16.3891752 L13.5503438,16.8653522 C13.5503438,16.8653522 13.2496005,17.0031929 13.5503438,17.3039363 C13.5503438,17.3039363 13.9889279,17.3039363 14.0766447,17.429246 C14.1643615,17.5670867 14.0014589,17.8051752 14.214273,18.0182018 C14.3147332,18.1184496 14.2019545,18.1307681 14.2520784,18.3064142 C14.2896713,18.4818478 14.2520784,18.4818478 14.5026978,18.6948743 C14.7658483,18.9079009 14.5904146,18.9079009 14.5528217,19.0833345 C14.5026978,19.2585558 14.2520784,19.8224496 15.2418129,19.9602903 C16.2442907,20.0858124 17.1337775,19.7096708 17.4222022,19.7347327 C18.9382376,19.9101664 19.1637952,20.1733168 19.4645385,20.5241841 C19.7652819,20.8748389 21.907866,21.9151221 23.0354412,20.4740602 C24.1632288,19.0455292 23.8624854,19.5592991 23.8624854,19.5592991"
                        id="Fill-1"
                    ></path>
                    <path
                        d="M8.42557924,13.8581947 C8.42557924,13.8581947 8.41304826,15.3867611 6.37071198,15.123823 C4.32816331,14.8606726 1.75952614,14.7103009 2.49885357,16.7902301 C2.84972083,15.8629381 4.89205711,16.4019823 6.35818101,16.6523894 C7.46090667,16.6523894 7.72384472,16.6899823 8.46317216,16.4019823 C10.8689067,14.7980177 8.77644649,12.0537345 12.5480571,9.68559292 C15.3547828,7.61819469 18.3993845,5.95178761 21.4817916,3.84679646 C24.7772253,1.07766372 22.1083403,-1.20729385e-14 22.1083403,-1.20729385e-14 C22.1083403,-1.20729385e-14 22.8351368,1.57890265 20.3040925,2.98215929 C16.7329775,5.80141593 11.8964465,7.944 10.1170483,9.7359292 C9.76618101,10.124177 9.11478278,10.7381947 8.98947304,11.8409204 L8.42557924,13.8581947 Z"
                        id="Fill-3"
                    ></path>
                    <path
                        d="M2.67426596,17.1410973 C5.33061994,18.1059823 7.36042525,19.1834336 9.91674384,20.4112566 C10.6809208,20.7873982 12.5480359,21.9525664 12.4603191,23.0427611 C11.9839297,23.9575221 11.2197527,24.0575575 10.7059828,24.4961416 C9.85408897,25.2229381 10.0044607,25.5487434 10.1796819,26.5635398 C10.4804253,27.6537345 11.5079651,27.7038584 11.9214872,27.7790442 C11.1696288,28.4055929 10.0796465,28.7063363 9.11476154,28.3178761 C8.25012437,27.7038584 7.93685003,27.1399646 8.30024826,25.9998584 C8.67617747,25.0224425 9.59093853,24.8346903 10.3553279,24.020177 C11.2824076,22.2159292 7.92431906,21.2510442 7.47320401,20.7873982 C6.24538101,20.260885 1.97253145,17.3415929 0.00538100533,18.3062655 C0.00538100533,18.3062655 -0.245238464,16.4896991 2.67426596,17.1410973"
                        id="Fill-5"
                    ></path>
                    <path
                        d="M15.4424146,25.8621239 C14.6780253,26.7140177 13.55045,26.9644248 12.2848217,26.3884248 C12.2848217,26.3756814 11.2447509,25.8621239 11.9214235,24.2832212 C12.7735297,23.0428673 14.7032996,23.1554336 14.9161137,21.6519292 C14.3399014,19.6847788 11.0569987,21.9526726 11.5705562,19.7223717 C11.3951226,19.371292 11.1695651,19.4339469 11.1321845,19.2336637 C11.0945916,19.095823 11.2823438,19.0081062 11.182096,18.8953274 C11.182096,18.8953274 10.9565385,18.7071504 10.9440076,18.5695221 C11.0317244,18.4064071 11.0569987,18.168531 11.0569987,17.9680354 C10.1297067,17.7800708 10.1171757,17.4793274 10.5557598,17.0532743 C10.7562553,16.7151504 11.5705562,16.0006726 11.2322199,15.5123894 L11.0945916,15.3116814 C11.4452465,9.44761062 18.1739545,9.19699115 21.2187686,5.35019469 L21.3939899,4.47323894 C21.983158,4.59854867 22.0834058,5.23762832 22.271158,5.68874336 C22.1084677,7.24237168 20.7049987,7.64336283 19.6523969,8.49525664 C17.6601845,10.512531 13.6630164,11.1390796 12.9865562,14.2966726 C12.3976005,14.9357522 12.6482199,15.4119292 12.7735297,15.8630442 C12.8111226,16.0384779 12.8111226,16.1011327 12.7735297,16.2640354 C12.7985916,16.0883894 12.5229102,16.6524956 12.1219191,17.3540177 C12.0717952,17.5670442 12.598096,17.6046372 12.7234058,17.7299469 C12.8361845,17.9304425 12.7108748,18.0432212 12.7860607,18.3063717 C12.7860607,18.5695221 12.9614943,18.3189027 13.0492111,18.5695221 C13.0366801,18.644708 12.9364323,18.5569912 13.0116182,18.8452035 C13.3123615,19.0454867 13.2246447,19.1835398 13.2872996,19.408885 C13.1619899,19.7850265 13.3750164,19.9353982 13.3750164,19.9980531 C13.55045,20.9376637 17.5098129,19.5592566 16.6579191,22.1780177 C15.4674766,23.2682124 13.1369279,22.8421593 13.5001137,24.9724248 C14.1642553,25.9623717 14.7532111,25.6866903 15.4424146,25.8621239"
                        id="Fill-7"
                    ></path>
                </g>
            </g>
        </g>
    </svg>);
};

const CreditCardIcon = ({width = "24", height = "22"}) => {
    return (<svg
        width={`${width}px`}
        height={`${height}px`}
        viewBox="0 0 24 22"
        version="1.1"
    >
        <g
            id="Page-1"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <g
                id="payments---eCheck"
                transform="translate(-726.000000, -352.000000)"
                stroke="#000000"
            >
                <g
                    id="credit-card-icon"
                    transform="translate(726.000000, 352.000000)"
                >
                    <path
                        d="M2.504,7.5 L17.504,7.5 C18.60857,7.5 19.504,8.3954305 19.504,9.5 L19.504,19.5 C19.504,20.60457 18.60857,21.5 17.504,21.5 L2.504,21.5 C1.3994305,21.5 0.504,20.60457 0.504,19.5 L0.504,9.5 C0.504,8.3954305 1.3994305,7.5 2.504,7.5 Z"
                        id="Stroke-1"
                    ></path>
                    <path
                        d="M3.004,9.5 L5.004,9.5 C5.280142,9.5 5.504,9.7238576 5.504,10 L5.504,12 C5.504,12.276142 5.280142,12.5 5.004,12.5 L3.004,12.5 C2.7278576,12.5 2.504,12.276142 2.504,12 L2.504,10 C2.504,9.7238576 2.7278576,9.5 3.004,9.5 Z"
                        id="Stroke-2"
                    ></path>
                    <line
                        x1="2.504"
                        y1="15.5"
                        x2="7.504"
                        y2="15.5"
                        id="Stroke-3"
                    ></line>
                    <line
                        x1="2.504"
                        y1="17.5"
                        x2="6.504"
                        y2="17.5"
                        id="Stroke-4"
                    ></line>
                    <path
                        d="M15.500002,14.9999996 C14.92561,14.9990484 14.378794,15.2462094 14.000002,15.6779996 C13.450048,15.0536764 12.571022,14.8350344 11.792669,15.1289647 C11.014316,15.422895 10.49923,16.167997 10.49923,17 C10.49923,17.832002 11.014316,18.577104 11.792669,18.871035 C12.571022,19.164965 13.450048,18.946323 14.000002,18.322 C14.60879,19.013113 15.610837,19.199123 16.427102,18.772544 C17.243368,18.345965 17.662783,17.4171 17.442985,16.522702 C17.223188,15.6283036 16.421012,14.9996443 15.500002,14.9999996 Z"
                        id="Stroke-5"
                    ></path>
                    <path
                        d="M12.5,14.9999999 C13.4413528,14.9997833 14.255433,15.6560446 14.455,16.576"
                        id="Stroke-6"
                    ></path>
                    <path
                        d="M21.5,13.5 C22.60457,13.5 23.5,12.60457 23.5,11.5 L23.5,2.5 C23.5,1.3954305 22.60457,0.5 21.5,0.5 L6.5,0.5 C5.3954305,0.5 4.5,1.3954305 4.5,2.5 L4.5,5.5"
                        id="Stroke-7"
                    ></path>
                    <line x1="4.504" y1="4.5" x2="23.504" y2="4.5" id="Stroke-8"></line>
                </g>
            </g>
        </g>
    </svg>);
};

const DebitCardIcon = ({width = "24", height = "18"}) => {
    return (<svg
        width={`${width}px`}
        height={`${height}px`}
        viewBox="0 0 24 18"
        version="1.1"
    >
        <g
            id="Page-1"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <g
                id="payments---HHA/HHS"
                transform="translate(-888.000000, -357.000000)"
                stroke="#000000"
            >
                <g id="debit-card-icon" transform="translate(888.000000, 358.000000)">
                    <path
                        d="M2.504,0 L21.504,0 C22.60857,0 23.504,0.8954305 23.504,2 L23.504,14 C23.504,15.10457 22.60857,16 21.504,16 L2.504,16 C1.3994305,16 0.504,15.10457 0.504,14 L0.504,2 C0.504,0.8954305 1.3994305,0 2.504,0 Z"
                        id="Stroke-1"
                    ></path>
                    <line x1="0.504" y1="4" x2="23.504" y2="4" id="Stroke-2"></line>
                    <line x1="20.504" y1="8" x2="17.504" y2="8" id="Stroke-3"></line>
                    <line x1="11.504" y1="8" x2="3.504" y2="8" id="Stroke-4"></line>
                    <line x1="6.504" y1="11" x2="3.504" y2="11" id="Stroke-5"></line>
                </g>
            </g>
        </g>
    </svg>);
};

const ECheckIcon = ({width = "24", height = "24"}) => {
    return (<svg
        width={`${width}px`}
        height={`${height}px`}
        viewBox="0 0 24 24"
        version="1.1"
    >
        <g
            id="Page-1"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <g
                id="payments---HHA/HHS"
                transform="translate(-563.000000, -351.000000)"
                stroke="#000000"
            >
                <g id="e-check-icon" transform="translate(563.000000, 352.000000)">
                    <line x1="2.5" y1="19.5" x2="9.5" y2="19.5" id="Stroke-1"></line>
                    <path
                        d="M14,18.616 L14.751,17.8649996 C15.005821,17.6103838 15.377892,17.5124979 15.725021,17.6087502 C16.07215,17.7050024 16.340684,17.9805157 16.428,18.3299996 L16.5,18.616 L17.318,18.0709996 C17.714676,17.8064922 18.242921,17.8588143 18.58,18.1959996 L19,18.616 L21,18.616"
                        id="Stroke-2"
                    ></path>
                    <line
                        x1="2.504"
                        y1="16.616"
                        x2="7.504"
                        y2="16.616"
                        id="Stroke-3"
                    ></line>
                    <line
                        x1="14.075"
                        y1="4.505"
                        x2="16.197"
                        y2="6.627"
                        id="Stroke-4"
                    ></line>
                    <path
                        d="M18.8133933,1.46469292 L19.2376499,1.88896438 C19.7062711,2.35760191 19.7062576,3.11739964 19.2376203,3.58602058 L10.5400554,12.2832817 L8.41877215,10.1619244 L17.1163371,1.46466328 C17.5849744,0.996042335 18.3447723,0.996055606 18.8133933,1.46469292 L18.8133933,1.46469292 Z"
                        id="Stroke-5"
                    ></path>
                    <polyline
                        id="Stroke-6"
                        points="8.418 10.162 7.004 13.698 10.54 12.284"
                    ></polyline>
                    <line
                        x1="19.025"
                        y1="1.677"
                        x2="20.318"
                        y2="0.384"
                        id="Stroke-7"
                    ></line>
                    <path
                        d="M6.5,8.616 L1,8.616 C0.7238576,8.616 0.5,8.8398576 0.5,9.116 L0.5,21.116 C0.5,21.39214 0.7238576,21.616 1,21.616 L23,21.616 C23.27614,21.616 23.5,21.39214 23.5,21.116 L23.5,9.116 C23.5,8.8398576 23.27614,8.616 23,8.616 L18,8.616"
                        id="Stroke-8"
                    ></path>
                    <path
                        d="M17.004,11.616 L20.004,11.616 C20.280142,11.616 20.504,11.8398576 20.504,12.116 L20.504,14.116 C20.504,14.392142 20.280142,14.616 20.004,14.616 L17.004,14.616 C16.7278576,14.616 16.504,14.392142 16.504,14.116 L16.504,12.116 C16.504,11.8398576 16.7278576,11.616 17.004,11.616 Z"
                        id="Stroke-9"
                    ></path>
                    <path
                        d="M16.757,1.822996 L15.957,1.0229965 C15.5665,0.63261452 14.9335,0.63261452 14.543,1.0229965 L12.5,3.069996"
                        id="Stroke-10"
                    ></path>
                </g>
            </g>
        </g>
    </svg>);
};

const DownArrow = ({height = "24px", width = "24px", color = "#6e86c4"}) => {
    return (<svg
        version="1.2"
        baseProfile="tiny-ps"
        viewBox="0 0 376 326"
        width={width}
        height={height}
    >
        <g id="Layer">
            <path
                id="Layer"
                fill={color ? color : "#6e86c4"}
                d="M167.2 22.7C166.5 23 165.3 24.5 164.5 26C163.2 28.5 163 37.1 163 82.2L163 135.5L143.2 115.7C118.5 91 120.9 91.6 105.7 106.8C96.2 116.3 95 117.9 95 121C95 124.2 97.9 127.3 138.3 167.7C167.1 196.5 182.4 211.1 184.3 211.6C185.8 211.9 188.2 211.9 189.8 211.5C191.6 211.1 207 196.4 235.8 167.7C276.4 127.1 279 124.3 279 121C279 117.8 277.9 116.3 268.2 106.7C253.1 91.6 255.5 91 230.8 115.7L211 135.5L211 82.2C211 26 210.9 24.3 206.5 22.6C204.5 21.9 169.1 21.9 167.2 22.7Z"
            />
            <path
                id="Layer"
                fill={color ? color : "#6e86c4"}
                d="M31 205.7C30.2 206 28.5 207.2 27.3 208.3L25 210.3L25 245.7C25 275.4 25.2 281.6 26.5 284C29.8 290.4 18.8 290 187 290C355.2 290 344.2 290.4 347.5 284C348.8 281.6 349 275.4 349 245.6L349 210.2L345.9 207.6C342.8 205 342.8 205 323.9 205C296.8 205 297 204.8 297 227.5C297 240.7 296.8 242 295.1 243C292.4 244.4 81.6 244.4 78.9 243C77.2 242 77 240.7 77 227.4C77 211.5 76.2 208.3 71.5 206.2C68.9 205 34.1 204.6 31 205.7Z"
            />
            <path
                id="Layer"
                d="M-53.2 297.7C-52 297.9 -50.2 297.9 -49.2 297.7C-48.3 297.4 -49.3 297.2 -51.5 297.3C-53.7 297.3 -54.5 297.5 -53.2 297.7Z"
            />
            <path
                id="Layer"
                fillRule="evenodd"
                fill={color ? color : "#6e86c4"}
                d="M-48.5 301.1C-48.5 303.1 -52.4 303.4 -54 301.5C-54.8 300.5 -54.9 300 -54.1 300C-53.5 300 -53 300.6 -53 301.2C-53 301.9 -52.5 301.7 -51.9 300.7C-50.7 298.7 -48.5 298.9 -48.5 301.1ZM-50 300C-50.5 300 -51 300.4 -51 301C-51 301.5 -50.5 302 -50 302C-49.4 302 -49 301.5 -49 301C-49 300.4 -49.4 300 -50 300Z"
            />
            <path
                id="Layer"
                fill={color ? color : "#6e86c4"}
                d="M-53.2 305.7C-52 305.9 -50.2 305.9 -49.2 305.7C-48.3 305.4 -49.3 305.2 -51.5 305.3C-53.7 305.3 -54.5 305.5 -53.2 305.7Z"
            />
            <path
                id="Layer"
                fillRule="evenodd"
                fill={color ? color : "#6e86c4"}
                d="M-48.2 309.3C-47.9 310.6 -48.6 311 -51.4 311C-53.9 311 -55 310.6 -55 309.5C-55 308.7 -54.5 308 -53.9 308C-53.4 308 -53.2 308.4 -53.5 309C-53.8 309.5 -53.7 310 -53.2 310C-52.6 310 -51.9 309.3 -51.6 308.4C-50.9 306.5 -48.6 307.1 -48.2 309.3ZM-50 308C-50.5 308 -51 308.4 -51 309C-51 309.5 -50.5 310 -50 310C-49.4 310 -49 309.5 -49 309C-49 308.4 -49.4 308 -50 308Z"
            />
            <path
                id="Layer"
                fillRule="evenodd"
                fill={color ? color : "#6e86c4"}
                d="M-49.6 313.6C-47.6 315.6 -47.5 316.6 -49.5 315C-50.5 314.1 -51 314.1 -51 314.9C-51 315.5 -51.9 316 -53 316C-54.9 316 -55.7 314 -54.3 312.7C-53.2 311.5 -51.2 311.9 -49.6 313.6ZM-53 313C-53.5 313 -54 313.4 -54 314C-54 314.5 -53.5 315 -53 315C-52.4 315 -52 314.5 -52 314C-52 313.4 -52.4 313 -53 313Z"
            />
            <path
                id="Layer"
                fillRule="evenodd"
                fill={color ? color : "#6e86c4"}
                d="M-49.6 318.6C-47.6 320.6 -47.5 321.6 -49.5 320C-50.5 319.1 -51 319.1 -51 319.9C-51 320.5 -51.9 321 -53 321C-54.9 321 -55.7 319 -54.3 317.7C-53.2 316.5 -51.2 316.9 -49.6 318.6ZM-52.4 318C-52.7 318 -53.2 318.4 -53.5 319C-53.8 319.5 -53.6 320 -53.1 320C-52.5 320 -52 319.5 -52 319C-52 318.4 -52.2 318 -52.4 318Z"
            />
            <path
                id="Layer"
                fillRule="evenodd"
                fill={color ? color : "#6e86c4"}
                d="M-49.6 323.6C-47.6 325.6 -47.5 326.6 -49.5 325C-50.5 324.1 -51 324.1 -51 324.9C-51 325.5 -51.9 326 -53 326C-54.9 326 -55.7 324 -54.3 322.7C-53.2 321.5 -51.2 321.9 -49.6 323.6ZM-53 323C-53.5 323 -54 323.4 -54 324C-54 324.5 -53.5 325 -53 325C-52.4 325 -52 324.5 -52 324C-52 323.4 -52.4 323 -53 323Z"
            />
            <path
                id="Layer"
                fill={color ? color : "#6e86c4"}
                d="M-54.9 330.2C-54.8 332.1 -54.7 332.1 -54.3 330.7C-54 329.4 -53.3 329.1 -52.2 329.5C-48.4 331 -47.6 331.1 -50 329.6C-53.5 327.4 -55 327.6 -54.9 330.2Z"
            />
            <path
                id="Layer"
                fill={color ? color : "#6e86c4"}
                d="M-54.5 334.1C-54.9 334.7 -54.9 335.4 -54.6 335.7C-54.3 336.1 -54 335.8 -54 335.2C-54 333.5 -52 333.7 -49.8 335.7C-48.1 337.2 -48 337.2 -48 334.9C-48 333.2 -48.3 332.9 -48.9 333.9C-49.5 334.8 -50 334.9 -50.4 334.1C-51.3 332.7 -53.7 332.7 -54.5 334.1Z"
            />
            <path
                id="Layer"
                fill={color ? color : "#6e86c4"}
                d="M-53 339.3C-53 341.1 -52.8 341.2 -52 340C-51.4 339 -51 338.9 -51 339.7C-51 340.4 -50.6 341 -50 341C-48.6 341 -49.9 338.3 -51.6 337.6C-52.5 337.2 -53 337.8 -53 339.3Z"
            />
            <path
                id="Layer"
                fill={color ? color : "#6e86c4"}
                d="M-50.7 344.7C-49.8 344.9 -48.2 344.9 -47.2 344.7C-46.3 344.4 -47.1 344.2 -49 344.2C-50.9 344.2 -51.7 344.4 -50.7 344.7Z"
            />
            <path
                id="Layer"
                fill={color ? color : "#6e86c4"}
                d="M-50 349.4C-50.6 350.2 -52.4 351.1 -53.8 351.3C-55.4 351.5 -54.6 351.7 -52 351.8C-49.5 351.8 -48.1 351.6 -48.8 351.3C-49.8 350.9 -49.8 350.5 -48.9 349.4C-48.3 348.6 -48 348 -48.3 348C-48.5 348 -49.3 348.6 -50 349.4Z"
            />
            <path
                id="Layer"
                fill={color ? color : "#6e86c4"}
                d="M-53 353.9C-53 354.5 -52.6 355.2 -52 355.5C-51.4 355.8 -51.3 355.4 -51.6 354.6C-52.3 352.8 -53 352.5 -53 353.9Z"
            />
            <path
                id="Layer"
                fill={color ? color : "#6e86c4"}
                d="M-49.4 354.7C-50 356.1 -49.9 356.2 -48.9 355.3C-48.2 354.6 -47.9 353.8 -48.2 353.5C-48.5 353.2 -49.1 353.7 -49.4 354.7Z"
            />
            <path
                id="Layer"
                fill={color ? color : "#6e86c4"}
                d="M-52.6 358.1C-52.9 358.7 -52.7 359.7 -52.1 360.3C-51.2 361.2 -51 361.1 -51.5 359.7C-52 358.5 -51.7 358 -50.5 358C-49.3 358 -49 358.5 -49.5 359.7C-50 361.1 -49.8 361.2 -48.9 360.3C-47.6 359 -48.5 357 -50.5 357C-51.3 357 -52.2 357.5 -52.6 358.1Z"
            />
            <path
                id="Layer"
                fill={color ? color : "#6e86c4"}
                d="M-53.6 362.9C-53.8 363.1 -53.7 363.6 -53.5 364C-53 364.9 -48 364.1 -48 363.1C-48 362.5 -52.9 362.2 -53.6 362.9Z"
            />
            <path
                id="Layer"
                fill={color ? color : "#6e86c4"}
                d="M-55 367.2C-55 369.3 -51.4 369.7 -50.7 367.7C-50.3 366.8 -49.9 366.9 -49.1 368C-48.2 369.3 -48 369.3 -48 367.7C-48 365.7 -51.6 365.3 -52.3 367.2C-52.7 368.2 -53.1 368.1 -53.9 367C-54.8 365.7 -55 365.7 -55 367.2Z"
            />
            <path
                id="Layer"
                fill={color ? color : "#6e86c4"}
                d="M-52.6 374.2C-52.5 374.9 -51.4 375.6 -50.2 375.8C-48.6 376 -48 375.6 -48 374.3C-48 372.8 -48.2 372.7 -49 374C-49.9 375.3 -50 375.3 -50 374C-50 372.8 -50.2 372.7 -50.9 373.9C-51.5 374.8 -51.9 374.9 -52.3 374.1C-52.6 373.4 -52.8 373.4 -52.6 374.2Z"
            />
            <path
                id="Layer"
                fillRule="evenodd"
                fill={color ? color : "#6e86c4"}
                d="M-48.2 379.3C-47.9 380.7 -48.6 381 -52.2 380.9C-54.6 380.9 -55.8 380.6 -55 380.3C-54.2 380 -53.1 379.1 -52.7 378.3C-51.6 376.4 -48.6 377.1 -48.2 379.3ZM-50.5 378C-51.3 378 -52 378.4 -52 379C-52 379.5 -51.3 380 -50.5 380C-49.7 380 -49 379.5 -49 379C-49 378.4 -49.7 378 -50.5 378Z"
            />
            <path
                id="Layer"
                fill={color ? color : "#6e86c4"}
                d="M-52.6 383.1C-52.9 383.7 -52.7 384.7 -52.1 385.3C-51.2 386.2 -51 386.1 -51.5 384.7C-52 383.5 -51.7 383 -50.5 383C-49.3 383 -49 383.5 -49.5 384.7C-50 386.1 -49.8 386.2 -48.9 385.3C-47.6 384 -48.5 382 -50.5 382C-51.3 382 -52.2 382.5 -52.6 383.1Z"
            />
            <path
                id="Layer"
                fill={color ? color : "#6e86c4"}
                d="M-55 387.7C-54.2 388.1 -52.9 389 -52.2 389.9C-51.1 391.3 -51.1 391.3 -51.6 389.7C-52 388.5 -51.7 388 -50.5 388C-49.3 388 -49 388.5 -49.5 389.7C-50 391.1 -49.8 391.2 -48.9 390.3C-47.1 388.5 -48.8 387 -52.8 387.1C-54.8 387.1 -55.8 387.4 -55 387.7Z"
            />
            <path
                id="Layer"
                fill={color ? color : "#6e86c4"}
                d="M-50 392.8C-52.2 393.8 -52.1 396.7 -49.8 397.3C-48.2 397.7 -48.1 397.6 -49.1 396.4C-50 395.3 -50 394.7 -49 393.5C-47.6 391.9 -47.7 391.8 -50 392.8Z"
            />
            <path
                id="Layer"
                fill={color ? color : "#6e86c4"}
                d="M-55 395C-55 395.5 -54.5 396 -54 396C-53.4 396 -53 395.5 -53 395C-53 394.4 -53.4 394 -54 394C-54.5 394 -55 394.4 -55 395Z"
            />
        </g>
    </svg>);
};
const IntakeFormIcon = ({width = "85", height = "113", color}) => {
    return (<svg width={`${width}px`} height={`${height}px`} version="1.1">
        <path
            fill={color ? color : "#6e86c4"}
            opacity="0.5529411764705883"
            d="M 56.5 12 L 67.5 12 L 69 13.5 L 67.5 13 L 56 13 L 56 41 L 68 41 L 68 16.5 L 69 16.5 L 69 40.5 L 67.5 42 L 56.5 42 L 55 40.5 L 55 13.5 L 56.5 12 Z "
        ></path>
        <path
            fill={color ? color : "#6e86c4"}
            opacity="0.5529411764705883"
            d="M 72.5 13 L 74.5 13 L 80 18.5 L 79.5 21 Q 79 15.5 74.5 14 Q 71.5 14.5 72.5 13 Z "
        ></path>
        <path
            fill={color ? color : "#6e86c4"}
            opacity="0.5529411764705883"
            d="M 39.5 17 L 43 19.5 L 42.5 21 L 40.5 18 L 39.5 17 Z "
        ></path>
        <path
            fill={color ? color : "#6e86c4"}
            opacity="0.5529411764705883"
            d="M 72.5 17 L 75 18.5 L 76 20.5 L 72.5 17 Z "
        ></path>
        <path
            fill={color ? color : "#6e86c4"}
            opacity="0.5529411764705883"
            d="M 0.5 20 L 37.5 20 L 40 22.5 L 39.5 74 L 39 22.5 L 37.5 21 L 0.5 21 L 0.5 20 Z "
        ></path>
        <path
            fill={color ? color : "#6e86c4"}
            opacity="0.5529411764705883"
            d="M 76.5 23 L 77 56.5 L 76 56.5 L 76.5 23 Z "
        ></path>
        <path
            fill={color ? color : "#6e86c4"}
            opacity="0.5529411764705883"
            d="M 9.5 27 L 0.5 37 L 9.5 27 Z "
        ></path>
        <path
            fill={color ? color : "#6e86c4"}
            opacity="0.5529411764705883"
            d="M 12.5 29 L 13 30.5 L 0 42.5 L 12.5 29 Z "
        ></path>
        <path
            fill={color ? color : "#6e86c4"}
            opacity="0.5529411764705883"
            d="M 56.5 45 L 67.5 45 L 69 46.5 L 69 83.5 L 67.5 85 L 68 83.5 L 68 46.5 L 67.5 46 L 56 46 L 56 83.5 L 57 84.5 L 55 83.5 L 55 46.5 L 56.5 45 Z "
        ></path>
        <path
            fill={color ? color : "#6e86c4"}
            opacity="0.5529411764705883"
            d="M 9.5 50 L 0.5 60 L 9.5 50 Z "
        ></path>
        <path
            fill={color ? color : "#6e86c4"}
            opacity="0.5529411764705883"
            d="M 12.5 52 L 13 53.5 L 0 65.5 L 12.5 52 Z "
        ></path>
        <path
            fill={color ? color : "#6e86c4"}
            opacity="0.5529411764705883"
            d="M 24.5 77 L 35.5 77 L 36 78.5 L 23 90.5 L 23 78.5 L 24.5 77 Z M 24 78 L 24 89 L 35 79 L 24 78 Z "
        ></path>
        <path
            fill={color ? color : "#6e86c4"}
            opacity="0.5529411764705883"
            d="M 42.5 77 L 44 77.5 L 24 96.5 L 23.5 98 L 23 96.5 L 42.5 77 Z "
        ></path>
        <path
            fill={color ? color : "#6e86c4"}
            opacity="0.5529411764705883"
            d="M 59.5 88 L 61 92.5 L 59 91.5 L 59.5 88 Z "
        ></path>
        <path
            fill={color ? color : "#6e86c4"}
            opacity="0.5529411764705883"
            d="M 64.5 88 L 65 91.5 L 63 92.5 L 64.5 88 Z "
        ></path>
        <path
            fill={color ? color : "#6e86c4"}
            opacity="0.5529411764705883"
            d="M 0.5 94 L 20 94.5 L 0.5 95 L 0.5 94 Z "
        ></path>
        <path
            fill={color ? color : "#6e86c4"}
            opacity="0"
            d="M 0 0 L 85 0 L 85 113 L 0.5 113 L 0 112.5 L 0 98 L 23.5 98 L 24 96.5 L 42.5 78 L 44 78 L 43 73.5 L 43 19.5 L 40.5 17 L 0 17 L 0 0 Z M 52 9 L 52 88 L 56 88 L 56 96 L 60 96 L 60 106 L 64 106 L 64 96 L 68 96 L 68 88 L 72 88 L 72 19 L 76 22 L 76 57 L 80 57 L 80 19 L 75 13 L 72 13 L 72 9 L 52 9 Z M 15 37 L 16 41 L 33 41 L 33 37 L 15 37 Z M 15 58 L 16 62 L 33 62 L 33 58 L 15 58 Z "
        ></path>
        <path
            fill={color ? color : "#6e86c4"}
            opacity="0"
            d="M 56 13 L 68 13 L 68 41 L 56 41 L 56 13 Z "
        ></path>
        <path
            fill={color ? color : "#6e86c4"}
            opacity="0"
            d="M 0 21 L 37.5 21 L 39 22.5 L 39 74 L 20 74 L 20 94 L 0 94 L 0 66.5 L 13 53.5 L 13 50 L 9.5 50 L 0.5 59 L 0 43.5 L 13 30.5 L 13 27 L 9.5 27 L 0.5 36 L 0 21 Z "
        ></path>
        <path
            fill={color ? color : "#6e86c4"}
            opacity="0"
            d="M 56 46 L 67.5 46 L 68 46.5 L 68 84 L 56.5 84 L 56 83.5 L 56 46 Z "
        ></path>
        <path
            fill={color ? color : "#6e86c4"}
            opacity="0"
            d="M 24 78 L 35 78.5 L 24 88.5 L 24 78 Z "
        ></path>
        <path
            fill={color ? color : "#6e86c4"}
            opacity="0"
            d="M 60 88 Q 66 86 64 92 Q 58 94 60 88 Z "
        ></path>
        <path
            fill={color ? color : "#6e86c4"}
            opacity="0.9882352941176471"
            d="M 53.5 9 L 70.5 9 L 72 10.5 Q 70.3 15.3 74.5 14 L 80 21.5 L 80 55.5 L 77 57 L 77 23.5 L 73.5 17 L 72 17.5 L 72 86.5 L 68 88 Q 69.8 94.1 66.5 96 L 64 96.5 L 64 104.5 L 61.5 106 L 60 104.5 L 60 96 L 56 94.5 L 56 88 L 53.5 88 L 52 86.5 L 52 10.5 L 53.5 9 Z M 57 12 L 55 14 L 55 41 L 57 42 L 68 42 L 69 41 L 69 17 L 68 16 L 69 14 L 68 12 L 57 12 Z M 57 45 L 55 47 L 55 84 Q 56 86 58 84 L 67 84 L 68 85 L 69 84 L 69 47 L 68 45 L 57 45 Z M 59 88 Q 58 92 61 93 L 63 92 Q 64 94 65 92 L 65 88 L 59 88 Z "
        ></path>
        <path
            fill={color ? color : "#6e86c4"}
            opacity="0.9882352941176471"
            d="M 0 17 L 38.5 17 L 42 19.5 L 43 21.5 L 43 74.5 L 44 77 L 42.5 77 L 23 96.5 L 22.5 98 L 0 98 L 0.5 95 L 20 95 L 20 75.5 L 21.5 74 L 40 74 L 40 22.5 L 37.5 20 L 0.5 20 L 0 17 Z M 25 77 L 23 79 L 23 91 L 36 79 L 36 77 L 25 77 Z "
        ></path>
        <path
            fill={color ? color : "#6e86c4"}
            opacity="0.9882352941176471"
            d="M 10.5 27 L 13 28.5 L 0.5 42 L 0 37.5 L 10.5 27 Z "
        ></path>
        <path
            fill={color ? color : "#6e86c4"}
            opacity="0.9882352941176471"
            d="M 16.5 37 L 31.5 37 L 33 38.5 L 31.5 41 L 16.5 41 L 15 39.5 L 16.5 37 Z "
        ></path>
        <path
            fill={color ? color : "#6e86c4"}
            opacity="0.9882352941176471"
            d="M 10.5 50 L 13 51.5 L 0.5 65 L 0 60.5 L 10.5 50 Z "
        ></path>
        <path
            fill={color ? color : "#6e86c4"}
            opacity="0.9882352941176471"
            d="M 16.5 58 L 31.5 58 L 33 59.5 L 31.5 62 L 16.5 62 L 15 60.5 L 16.5 58 Z "
        ></path>
    </svg>);
};

const MousePointerIcon = ({width = "24", height = "24", color}) => {
    return (<svg width={`${width}px`} height={`${height}px`} style={{enableBackground: "new 0 0 40 40"}} version="1.1"
                 viewBox="0 0 40 40">
        <path clipRule="evenodd"
              d="M17,24l4.5,8l-3.4,2l-4.6-8.1L9,32V12l16,12   H17z"
              fill={color ? color : "#6e86c4"}
            // fill="#ECF0F1"
              fillRule="evenodd"
              id="Mouse_Cursor_1_"
        />
        {/* <path clip-rule="evenodd"
        d="M20,21l4.5,8l-3.4,2l-4.6-8.1L12,29V9l16,12H20   z"
        fill="#2C3E50"
        fill-rule="evenodd"
        id="Mouse_Cursor"
      /> */}
    </svg>);
};

const AddCardIcon = ({width = "1em", height = "1em", color = "#fff", fill = "#6e86c4", style}) => {
    return (

        <svg
            stroke="currentColor"
            fill={fill}
            color={color}
            strokeWidth="0"
            viewBox="0 0 1024 1024"
            height={height}
            width={width}
            style={style}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z">
            </path>
        </svg>);
};

const SwipeCardIcon = ({style}) => {
    return (

        <svg
            style={style}
            viewBox="4.957 5.271 61.333 42.667"
            // preserveAspectRatio="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g transform="matrix(0.133333, 0, 0, -0.133333, -284.376029, 235.938001)">
                <path d="M 2630 1690 L 2465.99 1690 C 2447.51 1690 2429.98 1681.67 2418.24 1667.25 L 2404.2 1650"
                    // style="fill:none;stroke:#515151;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                      style={{
                          fill: "none",
                          stroke: "#515151",
                          strokeWidth: "20",
                          strokeLinecap: "round",
                          strokeLinejoin: "round",
                          strokeMiterlimit: "10",
                          strokeDasharray: "none",
                          strokeOpacity: "1"
                      }}
                      id="path246"/>
                <path
                    d="M 2473.54 1650 L 2429.02 1605.09 C 2419.11 1595.09 2419.11 1578.84 2429.02 1568.75 C 2434.02 1563.75 2440.53 1561.25 2447.11 1561.25 C 2453.61 1561.25 2460.12 1563.75 2465.12 1568.75 L 2498.58 1602.5 C 2498.58 1602.5 2522.29 1578.5 2555.93 1593.66 C 2560.61 1595.75 2565.52 1598.66 2570.6 1602.5"
                    // style="fill:none;stroke:#515151;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                    style={{
                        fill: "none",
                        stroke: "#515151",
                        strokeWidth: "20",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeMiterlimit: "10",
                        strokeDasharray: "none",
                        strokeOpacity: "1"
                    }}
                    id="path248"/>
                <path d="M 2630 1540 L 2591.22 1540 C 2591.22 1540 2580.79 1517.36 2560 1507.98"
                    // style="fill:none;stroke:#515151;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                      style={{
                          fill: "none",
                          stroke: "#515151",
                          strokeWidth: "20",
                          strokeLinecap: "round",
                          strokeLinejoin: "round",
                          strokeMiterlimit: "10",
                          strokeDasharray: "none",
                          strokeOpacity: "1"
                      }}
                      id="path250"/>
                <path d="M 2560 1460 L 2220 1460"
                    // style="fill:none;stroke:#515151;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                      style={{
                          fill: "none",
                          stroke: "#515151",
                          strokeWidth: "20",
                          strokeLinecap: "round",
                          strokeLinejoin: "round",
                          strokeMiterlimit: "10",
                          strokeDasharray: "none",
                          strokeOpacity: "1"
                      }}
                      id="path252"/>
                <path d="M 2560 1510 L 2220 1510"
                    // style="fill:none;stroke:#515151;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                      style={{
                          fill: "none",
                          stroke: "#515151",
                          strokeWidth: "20",
                          strokeLinecap: "round",
                          strokeLinejoin: "round",
                          strokeMiterlimit: "10",
                          strokeDasharray: "none",
                          strokeOpacity: "1"
                      }}
                      id="path254"/>
                <path d="M 2630 1730 L 2630 1510"
                    // style="fill:none;stroke:#515151;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                      style={{
                          fill: "none",
                          stroke: "#515151",
                          strokeWidth: "20",
                          strokeLinecap: "round",
                          strokeLinejoin: "round",
                          strokeMiterlimit: "10",
                          strokeDasharray: "none",
                          strokeOpacity: "1"
                      }}
                      id="path256"/>
                <path d="M 2170 1560 L 2330 1560"
                    // style="fill:none;stroke:#515151;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                      style={{
                          fill: "none",
                          stroke: "#515151",
                          strokeWidth: "20",
                          strokeLinecap: "round",
                          strokeLinejoin: "round",
                          strokeMiterlimit: "10",
                          strokeDasharray: "none",
                          strokeOpacity: "1"
                      }}
                      id="path258"/>
                <path d="M 2190 1600 L 2290 1600"
                    // style="fill:none;stroke:#515151;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                      style={{
                          fill: "none",
                          stroke: "#515151",
                          strokeWidth: "20",
                          strokeLinecap: "round",
                          strokeLinejoin: "round",
                          strokeMiterlimit: "10",
                          strokeDasharray: "none",
                          strokeOpacity: "1"
                      }}
                      id="path260"/>
                <path
                    d="M 2220 1530 L 2220 1434.35 C 2220 1420.9 2230.15 1410 2242.67 1410 L 2537.33 1410 C 2549.85 1410 2560 1420.9 2560 1434.35 L 2560 1462.18 L 2560 1590"
                    // style="fill:none;stroke:#515151;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                    style={{
                        fill: "none",
                        stroke: "#515151",
                        strokeWidth: "20",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeMiterlimit: "10",
                        strokeDasharray: "none",
                        strokeOpacity: "1"
                    }}
                    id="path262"/>
                <path d="M 2500 1650 L 2242.88 1650 C 2230.24 1650 2220 1639.1 2220 1625.65 L 2220 1600"
                    // style="fill:none;stroke:#515151;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                      style={{
                          fill: "none",
                          stroke: "#515151",
                          strokeWidth: "20",
                          strokeLinecap: "round",
                          strokeLinejoin: "round",
                          strokeMiterlimit: "10",
                          strokeDasharray: "none",
                          strokeOpacity: "1"
                      }}
                      id="path264"/>
            </g>
        </svg>

    );
};

// style={{
//     fill: "none",
//         stroke: "#515151",
//         strokeWidth: "20",
//         strokeLinecap: "round",
//         strokeLinejoin: "round",
//         strokeMiterlimit: "10",
//         strokeDasharray: "none",
//         strokeOpacity: "1"
// }}


const PeopleIcon = ({width = "24px", color = "#6e86c4"}) => {
    return (<svg
            x="0px" y="0px"
            width={width}
            viewBox="0 0 512 512" style={{enableBackground: "new"}}>
            <g>
                <g>
                    <path
                        style={{
                            fill: color ? color : "#6e86c4", stroke: color ? color : "#6e86c4",
                        }}

                        d="M437.76,195.421c14.561-14.261,23.04-33.742,23.04-54.621c0-42.346-34.45-76.8-76.8-76.8
  c-13.992,0-27.758,3.846-39.825,11.125c-4.033,2.438-5.333,7.679-2.9,11.717c2.433,4.038,7.683,5.325,11.717,2.9
  c9.408-5.675,20.125-8.675,31.008-8.675c32.933,0,59.733,26.796,59.733,59.733c0,20.283-10.158,38.979-27.208,50.037
  c-14.317,9.392-32.467,12.1-49.042,7.379c-4.483-1.292-9.25,1.325-10.55,5.858c-1.292,4.533,1.333,9.254,5.867,10.55
  c6.9,1.975,14.033,2.975,21.2,2.975c13.418,0,26.388-3.66,37.903-10.27c43.806,15.873,73.03,57.232,73.03,104.137v42.667h-77.812
  c-6.044-56.996-41.902-106.872-94.205-130.555c16.644-16.946,26.95-40.138,26.95-65.711C349.867,106.108,307.758,64,256,64
  c-51.758,0-93.867,42.108-93.867,93.867c0,25.581,10.312,48.78,26.965,65.728c-17.602,7.997-33.927,19.185-47.773,32.952
  c-26.543,26.619-42.695,60.784-46.529,97.588H17.067v-42.667c0-29.55,11.542-57.412,32.467-78.425
  c11.519-11.446,25.543-20.178,40.643-25.666C101.694,213.96,114.625,217.6,128,217.6c7.167,0,14.3-1,21.2-2.975
  c4.533-1.296,7.158-6.017,5.867-10.55c-1.3-4.533-6.067-7.146-10.55-5.858c-16.567,4.729-34.708,2.025-49.083-7.4
  c-17.008-11.038-27.167-29.733-27.167-50.017c0-32.937,26.8-59.733,59.733-59.733c10.883,0,21.6,3,31.008,8.675
  c4.05,2.425,9.275,1.125,11.717-2.9c2.433-4.037,1.133-9.279-2.9-11.717C155.758,67.846,141.992,64,128,64
  c-42.35,0-76.8,34.454-76.8,76.8c0,20.863,8.465,40.329,22.984,54.577c-13.533,6.291-26.032,14.976-36.717,25.59
  C13.308,245.233,0,277.371,0,311.467v51.2c0,4.713,3.817,8.533,8.533,8.533h85.333v68.267c0,4.713,3.817,8.533,8.533,8.533h307.2
  c4.717,0,8.533-3.821,8.533-8.533V371.2h85.333c4.717,0,8.533-3.821,8.533-8.533v-51.2
  C512,261.012,482.678,216.128,437.76,195.421z M179.2,157.867c0-42.346,34.45-76.8,76.8-76.8c42.35,0,76.8,34.454,76.8,76.8
  s-34.45,76.8-76.8,76.8C213.65,234.667,179.2,200.212,179.2,157.867z M401.067,430.933H110.933V371.2
  c0-38.692,15.083-75.129,42.45-102.579c14.417-14.34,31.895-25.463,50.634-32.659c14.895,9.947,32.767,15.771,51.983,15.771
  c19.248,0,37.151-5.841,52.06-15.818c55.778,21.431,93.007,75.205,93.007,135.285V430.933z"/>
                </g>
            </g>
        </svg>


    );
};

const PersonIcon = ({width = "24px", color="#6e86c4"}) => {
    return (<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                 width="24" height="24" viewBox="0 0 512 512"
                 preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
               fill={color} stroke="none">
                <path d="M2430 5114 c-318 -41 -573 -161 -793 -373 -487 -469 -539 -1230 -121
-1767 401 -516 1135 -662 1699 -337 498 287 755 845 649 1406 -99 519 -517
941 -1037 1048 -99 20 -318 33 -397 23z"/>
                <path d="M1490 2350 c-443 -78 -849 -353 -1102 -746 -53 -83 -118 -224 -118
-257 0 -66 190 -334 370 -521 439 -457 981 -729 1605 -807 130 -17 492 -16
620 0 506 65 956 254 1345 565 121 96 358 341 452 466 105 141 188 275 188
306 0 30 -56 153 -105 229 -171 267 -409 485 -676 618 -195 97 -438 164 -561
155 -42 -3 -70 -13 -110 -38 -144 -91 -190 -116 -270 -151 -199 -87 -402 -125
-618 -116 -276 11 -508 85 -739 237 -50 33 -103 62 -118 66 -16 3 -35 7 -43 9
-8 2 -62 -5 -120 -15z"/>
            </g>
        </svg>);
};

const DollarSignIcon = ({width, height, color}) => {
    return (<svg
            width={width}
            height={height}
            viewBox="0 0 320 512">
            <path
                style={{
                    fill: color ? color : "#6e86c4", stroke: color ? color : "#6e86c4",
                }}
                d="M160 0c17.7 0 32 14.3 32 32V67.7c1.6 .2 3.1 .4 4.7 .7c10.6 1.6 42.1 6.7 55.1 10c17.1 4.3 27.5 21.7 23.2 38.9s-21.7 27.5-38.9 23.2c-9.3-2.4-37.6-7-48.9-8.7c-32.1-4.8-59.6-2.4-78.5 4.9c-18.3 7-25.9 16.9-27.9 28c-1.9 10.7-.5 16.8 1.3 20.6c1.9 4 5.6 8.5 12.9 13.4c16.2 10.8 41.1 17.9 73.3 26.7l2.8 .8c28.4 7.7 63.2 17.2 89 34.3c14.1 9.4 27.3 22.1 35.5 39.7c8.3 17.8 10.1 37.8 6.3 59.1c-6.9 38-33.1 63.4-65.6 76.7c-13.7 5.6-28.6 9.2-44.4 11V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.1c-.4-.1-.9-.1-1.3-.2l-.2 0 0 0c-24.4-3.8-64.5-14.3-91.5-26.3c-16.2-7.2-23.4-26.1-16.2-42.2s26.1-23.4 42.2-16.2c20.9 9.3 55.3 18.4 75.2 21.6c31.9 4.7 58.2 2 76-5.3c16.9-6.9 24.6-16.9 26.8-28.9c1.9-10.7 .5-16.8-1.3-20.6c-1.9-4-5.6-8.5-12.9-13.4c-16.2-10.8-41.1-17.9-73.3-26.7l-2.8-.8c-28.4-7.7-63.2-17.2-89-34.3c-14.1-9.4-27.3-22.1-35.5-39.7c-8.3-17.8-10.1-37.8-6.3-59.1C25 114.1 53 89.3 86 76.7c13-5 27.2-8.2 42-10V32c0-17.7 14.3-32 32-32z"/>
        </svg>


    );
};


const TrashCanIcon = ({width, height, color}) => {
    return (<svg
        width={width}
        height={height}
        viewBox="0 0 448 512">
        <path
            style={{
                fill: color ? color : "#6e86c4", stroke: color ? color : "#6e86c4",
            }}
            d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z"/>
    </svg>);
};

const CheckBoxIcon = ({width = "5px", height = "5px", color}) => {

    return (<svg xmlns="http://www.w3.org/2000/svg"
                 viewBox="0 0 50 50"
                 width={width}
                 height={height}
    >
        <path
            style={{
                fill: color ? color : "#6e86c4", stroke: color ? color : "#6e86c4",
            }}
            d="M 11 4 C 7.101563 4 4 7.101563 4 11 L 4 39 C 4 42.898438 7.101563 46 11 46 L 39 46 C 42.898438 46 46 42.898438 46 39 L 46 15 L 44 17.3125 L 44 39 C 44 41.800781 41.800781 44 39 44 L 11 44 C 8.199219 44 6 41.800781 6 39 L 6 11 C 6 8.199219 8.199219 6 11 6 L 37.40625 6 L 39 4 Z M 43.25 7.75 L 23.90625 30.5625 L 15.78125 22.96875 L 14.40625 24.4375 L 23.3125 32.71875 L 24.09375 33.4375 L 24.75 32.65625 L 44.75 9.03125 Z"/>
    </svg>)
};


const SignOnline = ({width, height, color}) => {
    return (<svg
        width={width}
        height={height}
        x="0px" y="0px"
        viewBox="0 0 367.18 367.18"
        // style="enable-background:new 0 0 367.18 367.18;"
    >
        <path
            style={{
                fill: color ? color : "#6e86c4", stroke: color ? color : "#6e86c4",
            }}

            d="M362.266,68.69c-4.301-2.099-9.523-0.307-11.622,4.045l-8.499,17.51l-6.81-3.277l8.96-18.432
    c0-0.051,0.051-0.102,0.051-0.154c0.051-0.102,0.102-0.256,0.154-0.358c1.382-3.43,2.97-7.475,3.533-12.032
    c1.741-13.568-3.43-27.904-13.875-38.4c-9.933-9.984-25.139-15.616-39.578-14.746c-3.021,0.205-6.246,0.768-9.574,1.741
    c-5.274,1.536-10.445,4.198-15.309,7.936c-3.482,2.662-8.346,7.219-11.674,13.619c0,0.051-0.051,0.102-0.051,0.154
    s-0.051,0.102-0.051,0.102l-31.744,65.485c-0.154,0.256-0.307,0.512-0.461,0.819c-0.154,0.256-0.256,0.563-0.358,0.87
    L143.13,263.045c-1.229,2.56-1.843,5.427-1.741,8.294v0.051l1.843,54.63c0.205,5.325,2.202,10.291,5.53,14.182l-4.864,9.83
    c-2.15,4.301-0.358,9.523,3.942,11.674c1.229,0.614,2.56,0.922,3.84,0.922c3.226,0,6.298-1.792,7.834-4.864l4.71-9.574
    c0.717,0.051,1.382,0.102,2.099,0.102c4.813,0,9.574-1.485,13.568-4.454l44.134-32.358c0.922-0.666,1.792-1.485,2.56-2.304
    c0.154-0.154,0.256-0.307,0.41-0.461c0.973-1.126,1.792-2.406,2.458-3.738l98.253-202.394l6.81,3.277l-43.776,90.163
    c-2.099,4.301-0.307,9.523,4.045,11.622c1.229,0.614,2.509,0.87,3.789,0.87c3.226,0,6.349-1.792,7.834-4.915l47.002-96.819
    c0.256-0.358,0.512-0.768,0.717-1.178c0.205-0.41,0.307-0.768,0.461-1.178l11.725-24.166
    C368.41,76.011,366.567,70.789,362.266,68.69z M169.55,329.861c-1.587,1.126-3.584,1.382-5.376,0.717
    c-0.256-0.154-0.512-0.307-0.819-0.461c-0.154-0.051-0.256-0.102-0.41-0.154c-1.485-1.024-2.406-2.662-2.458-4.454l-1.229-35.584
    c11.52,8.96,24.781,15.411,38.912,18.995L169.55,329.861z M215.322,294.175c-20.941-2.048-40.499-11.571-55.04-26.829
    l77.21-159.13l55.142,26.675L215.322,294.175z M330.727,53.791c-0.307,2.406-1.28,4.966-2.253,7.373l-28.16,58.01l-55.194-26.675
    l28.262-58.266c1.536-2.816,3.942-5.632,6.912-7.885c3.072-2.355,6.349-4.096,9.472-5.018c2.099-0.614,4.096-0.973,5.786-1.075
    c9.472-0.563,19.763,3.226,26.214,9.677C328.321,36.485,331.751,45.65,330.727,53.791z"/>
        <path d="M116.609,347.013c-2.202-0.051-4.762,0-7.424,0c-13.926,0.154-39.885,0.41-48.179-8.858
    c-1.434-1.587-3.277-4.454-2.611-10.394c1.946-16.742,11.366-34.355,19.661-49.869l1.382-2.611
    c2.714-5.069,5.53-10.189,8.294-15.206c7.936-14.336,16.128-29.184,22.63-44.8c4.813-11.52,7.475-22.374,7.936-32.154
    c0.614-13.107-2.662-24.525-9.728-33.946c-8.448-11.315-20.787-19.61-37.683-25.446c-14.029-4.864-29.491-7.373-43.11-9.626
    c-6.144-1.024-11.981-1.946-17.357-3.072c-4.71-0.973-9.318,2.099-10.24,6.81c-0.973,4.71,2.099,9.318,6.81,10.24
    c5.734,1.178,11.725,2.15,18.022,3.174c25.856,4.25,55.194,9.011,69.632,28.314c8.55,11.418,8.448,27.904-0.358,48.998
    c-6.144,14.746-14.08,29.133-21.811,43.059c-2.765,5.018-5.632,10.24-8.397,15.411l-1.382,2.56
    c-9.062,16.896-19.302,36.045-21.606,56.064c-1.126,9.574,1.229,17.664,6.963,24.064c12.032,13.363,35.84,14.694,54.323,14.694
    c2.406,0,4.762,0,6.963-0.051c2.611,0,5.018-0.051,7.066,0c0.051,0,0.051,0,0.102,0c4.762,0,8.653-3.84,8.704-8.602
    C125.262,351.058,121.421,347.064,116.609,347.013z"/>
    </svg>)
};


const NewMessageIcon = ({width, height, color}) => {
    const newMessageIconStyle = {
        fill: "none",
        stroke: color ? color : "#6e86c4",
        strokeWidth: 40,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: 10,
        strokeDasharray: "none",
        strokeOpacity: 1,
    };

    return (<svg
        width={width}
        height={height}
        // x="0px" y="0px"
        viewBox="0 0 682.66669 682.66669">
        <defs id="defs337">
            <clipPath clipPathUnits="userSpaceOnUse" id="clipPath347">
                <path d="M 0,512 H 512 V 0 H 0 Z" id="path345"/>
            </clipPath>
        </defs>
        <mask id="custom">
            <rect id="bg" x="0" y="0" width="100%" height="100%" fill="white"/>
            <g transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"/>
        </mask>
        <g mask="url(#custom)">
            <g id="g339" transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)">
                <g id="g341">
                    <g id="g343" clipPath="url(#clipPath347)">
                        <g id="g349" transform="translate(27,390)">
                            <path d="m 0,0 197.316,-122.696 c 19.401,-12.063 43.967,-12.063 63.368,0 L 455,-1.865"
                                  style={newMessageIconStyle}
                                  id="path351"/>
                        </g>
                        <g id="g353" transform="translate(224,73)">
                            <path
                                d="m 0,0 h -144 c -33.137,0 -60,26.863 -60,60 v 231 c 0,33.137 26.863,60 60,60 h 352 c 33.137,0 60,-26.863 60,-60 v -76"
                                style={newMessageIconStyle}
                                id="path355"/>
                        </g>
                        <g id="g357" transform="translate(370.7246,42.3618)">
                            <path
                                d="m 0,0 -80.725,-22.362 23.912,78.725 109.804,109.559 c 15.621,15.621 40.947,15.621 56.569,0 15.621,-15.621 15.621,-40.947 0,-56.568 z"
                                style={newMessageIconStyle}
                                id="path359"/>
                        </g>
                        <g id="g361" transform="translate(409.5,186.5)">
                            <path d="M 0,0 47,-47"
                                  style={newMessageIconStyle}
                                  id="path363"/>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>)
};

const PrinterIcon = ({width = "24px", height = "24px", fill = "#6e86c4"}) => {
    return (

        <svg x="0px" y="0px" viewBox="0 0 512 512" style={{enableBackground: "new 0 0 512 512"}}
             height={`${height}`}
             width={`${width}`}
             fill={`${fill}`}
        >
            <path d="M388.813,0.691H123.181c-4.2,0-7.604,3.405-7.604,7.604V155.49c0,4.198,3.404,7.603,7.604,7.603
    c4.2,0,7.604-3.405,7.604-7.604V15.899h250.424v139.59c0,4.199,3.404,7.604,7.604,7.604s7.604-3.405,7.604-7.604V8.295
    C396.417,4.096,393.013,0.691,388.813,0.691z"/>
            <path d="M388.068,340.335h10.337c4.2,0,7.604-3.405,7.604-7.604c0-4.199-3.404-7.604-7.604-7.604H113.588
			c-4.2,0-7.604,3.405-7.604,7.604c0,4.199,3.404,7.604,7.604,7.604h10.337L111.15,459.469c-0.447,4.176,2.574,7.923,6.749,8.371
			c4.199,0.452,7.923-2.575,8.371-6.749l12.949-120.755h233.553l16.704,155.765H122.516l1.033-9.628
			c0.448-4.175-2.573-7.923-6.749-8.371c-4.164-0.446-7.923,2.574-8.371,6.749l-1.935,18.043c-0.231,2.145,0.462,4.288,1.904,5.894
			c1.443,1.605,3.499,2.521,5.656,2.521h283.887c2.157,0,4.214-0.917,5.656-2.521c1.442-1.605,2.134-3.747,1.904-5.894
			L388.068,340.335z"/>
            <path d="M421.259,171.663H49.536C22.222,171.663,0,193.886,0,221.2v169.497c0,27.314,22.222,49.537,49.536,49.537h46.788
			c4.2,0,7.604-3.405,7.604-7.604s-3.404-7.604-7.603-7.604H49.536c-18.929,0-34.328-15.4-34.328-34.329V221.2
			c0-18.929,15.4-34.329,34.328-34.329h371.723c4.2,0,7.604-3.405,7.604-7.604S425.46,171.663,421.259,171.663z"/>
            <path d="M462.453,171.663h-15.846c-4.2,0-7.604,3.405-7.604,7.604s3.404,7.604,7.604,7.604h15.846
			c18.935,0,34.339,15.4,34.339,34.329v169.497c0,18.929-15.405,34.329-34.339,34.329h-46.788c-4.2,0-7.604,3.405-7.604,7.604
			s3.404,7.604,7.604,7.604h46.788c27.32,0,49.547-22.222,49.547-49.537V221.2C512,193.886,489.773,171.663,462.453,171.663z"/>
            <path d="M422.273,289.271H89.727c-4.2,0-7.604,3.405-7.604,7.604v81.109c0,4.199,3.404,7.604,7.604,7.604h12.458
			c4.2,0,7.604-3.405,7.604-7.604s-3.404-7.604-7.604-7.604h-4.854v-65.901h317.339v65.901h-4.854c-4.2,0-7.604,3.405-7.604,7.604
			s3.404,7.604,7.604,7.604h12.458c4.2,0,7.604-3.405,7.604-7.604v-81.109C429.877,292.675,426.474,289.271,422.273,289.271z"/>
            <path d="M65.394,203.094c-18.728,0-33.964,15.236-33.964,33.964c0,18.728,15.236,33.964,33.964,33.964
			c18.728,0,33.964-15.236,33.964-33.964C99.358,218.33,84.122,203.094,65.394,203.094z M65.394,255.814
			c-10.342,0-18.756-8.414-18.756-18.756s8.414-18.756,18.756-18.756s18.756,8.414,18.756,18.756S75.736,255.814,65.394,255.814z"/>
            <path d="M144.475,203.094c-18.728,0-33.964,15.236-33.964,33.964c0,18.728,15.236,33.964,33.964,33.964
			c18.728,0,33.964-15.236,33.964-33.964C178.44,218.33,163.203,203.094,144.475,203.094z M144.475,255.814
			c-10.342,0-18.756-8.414-18.756-18.756s8.414-18.756,18.756-18.756c10.342,0,18.756,8.414,18.756,18.756
			S154.818,255.814,144.475,255.814z"/>
            <path d="M354.848,451.489H157.146c-4.2,0-7.604,3.405-7.604,7.604s3.404,7.604,7.604,7.604h197.703c4.2,0,7.604-3.405,7.604-7.604
			S359.049,451.489,354.848,451.489z"/>
            <path d="M350.034,417.017H161.959c-4.199,0-7.604,3.405-7.604,7.604s3.404,7.604,7.604,7.604h188.074
			c4.2,0,7.604-3.405,7.604-7.604S354.234,417.017,350.034,417.017z"/>
            <path d="M345.978,382.546H166.015c-4.2,0-7.604,3.405-7.604,7.604c0,4.199,3.404,7.604,7.604,7.604h179.963
			c4.2,0,7.604-3.405,7.604-7.604C353.582,385.951,350.179,382.546,345.978,382.546z"/>

        </svg>
    );
};

const ReadOnlyIcon = ({width = "24px", height = "24px", fill = "#6e86c4"}) => {
    return (
        <svg height={`${height}`}
             viewBox="0 0 32 32"
             width={`${width}`}
             fill={`${fill}`}
        >
            <path
                d="m16 25c-8.548 0-14-5.91-14-9s5.452-9 14-9 14 5.91 14 9-5.452 9-14 9zm0-16c-7.744 0-12 5.257-12 7s4.256 7 12 7 12-5.257 12-7-4.256-7-12-7z"/>
            <circle cx="16" cy="16" r="3.625"/>
            <path
                d="m16 20.625a4.625 4.625 0 1 1 4.625-4.625 4.631 4.631 0 0 1 -4.625 4.625zm0-7.25a2.625 2.625 0 1 0 2.625 2.625 2.629 2.629 0 0 0 -2.625-2.625z"/>
        </svg>
    );
};

const ProfileIcon = ({width = "24", height = "24", fill = "#6e86c4"}) => {
    return (
        <svg width={`${width}px`}
             height={`${height}px`} viewBox="0,0,256,256">
            <g fill={`${fill}`} fillRule="nonzero" stroke="none" strokeWidth="1" strokeLinecap="butt"
               strokeLinejoin="miter" strokeMiterlimit="10" strokeDasharray="" strokeDashoffset="0"
               fontFamily="none" fontWeight="none" fontSize="none" textAnchor="none">
                <g transform="scale(8,8)">
                    <path
                        d="M16,5c-3.85547,0 -7,3.14453 -7,7c0,2.41016 1.23047,4.55078 3.09375,5.8125c-3.56641,1.53125 -6.09375,5.07031 -6.09375,9.1875h2c0,-2.23047 0.91016,-4.23828 2.375,-5.6875l1.84375,2.3125l0.5625,0.71875l0.78125,-0.5l2.4375,-1.625l2.4375,1.625l0.84375,0.53125l0.5625,-0.8125l1.59375,-2.40625c1.56641,1.45703 2.5625,3.52734 2.5625,5.84375h2c0,-4.11719 -2.52734,-7.65625 -6.09375,-9.1875c1.86328,-1.26172 3.09375,-3.40234 3.09375,-5.8125c0,-3.85547 -3.14453,-7 -7,-7zM16,7c2.77344,0 5,2.22656 5,5c0,2.77344 -2.22656,5 -5,5c-2.77344,0 -5,-2.22656 -5,-5c0,-2.77344 2.22656,-5 5,-5zM16,19c1.38281,0 2.67969,0.35547 3.8125,0.96875l-1.09375,1.625l-2.15625,-1.4375l-0.5625,-0.34375l-0.5625,0.34375l-2.21875,1.5l-1.21875,-1.5625c1.17969,-0.68359 2.53516,-1.09375 4,-1.09375z"></path>
                </g>
            </g>
        </svg>
    );
};

const FormIcon = ({width = "24", height = "24", color = "#6e86c4"}) => {
    return (
        <svg width={`${width}px`}
             height={`${height}px`} viewBox="0,0,256,256">
            <g fill={`${color}`} fillRule="nonzero" stroke="none" strokeWidth="1" strokeLinecap="butt"
               strokeLinejoin="miter" strokeMiterlimit="10" strokeDasharray="" strokeDashoffset="0"
               fontFamily="none" fontWeight="none" fontSize="none" textAnchor="none">
                <g transform="scale(8,8)">
                    <path
                        d="M8,3c-1.09375,0 -2,0.90625 -2,2v22c0,1.09375 0.90625,2 2,2h16c1.09375,0 2,-0.90625 2,-2v-17.40625l-0.28125,-0.3125l-6,-6l-0.3125,-0.28125zM8,5h9v5c0,1.09375 0.90625,2 2,2h5v15h-16zM19,5.4375l4.5625,4.5625h-4.5625zM11,15v2h2v-2zM15,15v2h6v-2zM11,18v2h2v-2zM15,18v2h6v-2zM11,21v2h2v-2zM15,21v2h6v-2z"></path>
                </g>
            </g>
        </svg>
    );
};

const ShuffleEditIcon = ({width = "24px", height = "24px", fill = "#6e86c4"}) => {
    return (
        <svg enableBackground="new 0 0 512 512"
             width={`${width}`}
             viewBox="0 0 512 512"
             height={`${height}`}
             fill={`${fill}`}

             >
                    <path
                        d="m504.772 351.157-87.773-70.817c-5.905-4.77-13.85-5.69-20.735-2.398-6.745 3.225-10.934 9.782-10.93 17.107v28.944c-43.709-6.524-75.904-34.309-109.117-67.998 32.153-32.677 64.497-61.343 109.117-67.99v28.94c-.004 7.331 4.184 13.888 10.93 17.112 6.884 3.292 14.83 2.374 20.73-2.394l87.782-70.825c4.55-3.598 7.182-8.956 7.224-14.712.042-5.771-2.531-11.178-7.065-14.841l-87.351-70.475c-5.702-4.988-13.855-6.211-20.869-3.1-7.02 3.113-11.381 9.756-11.381 17.337v32.332c-75.003 6.312-122.257 48.056-165.6 92.174-14.769-13.436-28.337-24.115-42.221-33.262-4.612-3.039-10.813-1.761-13.852 2.85-3.038 4.612-1.763 10.813 2.85 13.852 12.846 8.462 25.479 18.399 39.271 30.91-.136.141-.273.282-.409.423-9.272 9.591-18.44 19.073-27.808 28.095-19.212-16.931-37.016-29.126-55.532-38.055-25.627-12.358-52.46-18.365-82.033-18.365h-15c-2.71 0-5-2.29-5-5v-30.001c0-2.71 2.29-5 5-5h15c16.451 0 32.363 1.464 47.294 4.353 5.427 1.056 10.669-2.497 11.718-7.918 1.049-5.422-2.497-10.668-7.919-11.717-16.18-3.13-33.37-4.717-51.093-4.717h-15c-13.785 0-25 11.215-25 25v30.001c0 13.785 11.215 25 25 25h15c55.606 0 93.34 24.299 122.781 50.036-32.806 28.695-69.748 49.961-122.781 49.961h-15c-13.785 0-25 11.215-25 25v30c0 13.785 11.215 25 25 25h15c49.529 0 92.958-12.178 132.767-37.229 17.067-10.74 32.486-23.167 46.966-36.336 46.529 47.284 92.556 86.125 165.602 92.192v32.326c0 7.581 4.361 14.225 11.381 17.337 2.58 1.144 5.313 1.702 8.022 1.702 4.656 0 9.241-1.648 12.847-4.802l87.355-70.48c4.528-3.659 7.103-9.066 7.061-14.837-.043-5.757-2.677-11.116-7.229-14.715zm-464.772 14.843h-15c-2.71 0-5-2.29-5-5v-30c0-2.71 2.29-5 5-5h15c38.286 0 72.694-10.297 105.189-31.48 28.321-18.462 51.829-42.777 74.562-66.292 48.733-50.408 94.765-98.021 176.007-101.471 5.353-.228 9.575-4.633 9.575-9.991v-40.141l85.985 69.375-85.985 69.375v-38.491c0-2.768-1.146-5.412-3.168-7.302-2.021-1.891-4.723-2.859-7.497-2.676-64.364 4.289-105.952 47.305-146.173 88.908-52.372 54.17-106.527 110.186-208.495 110.186zm365.334 69.376v-40.141c0-5.358-4.223-9.764-9.576-9.991-71.545-3.038-114.663-38.96-161.481-86.54 9.59-9.355 18.851-18.908 27.995-28.366 38.673 39.204 76.4 71.026 132.397 74.758 2.759.178 5.476-.785 7.497-2.676s3.168-4.535 3.168-7.302v-38.491l85.985 69.375z"/>
                    <path
                        d="m132.315 163.441c5.522 0 10-4.477 10-10s-4.478-10-10-10h-.007c-5.522 0-9.996 4.477-9.996 10s4.481 10 10.003 10z"/>
        </svg>
    );
};

const ApplePayIcon = ({width = "24", height = "24"}) => {
    return (<svg
        width={`${width}px`}
        height={`${height}px`}
        viewBox="0 0 24 24"
        version="1.1"
    >
        <g
            id="applepay-icon"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <rect
                x="0"
                y="4"
                width="24"
                height="16"
                rx="2"
                stroke="#000000"
                strokeWidth="1"
                fill="white"
            />
            <g transform="translate(2, 8)">
                <path
                    d="M4.5,1.5 C4.3,1.5 4.2,1.4 4.1,1.3 C3.9,1.1 3.8,0.9 3.8,0.7 C3.8,0.5 3.9,0.3 4.1,0.2 C4.3,0 4.5,0 4.7,0.1 C4.9,0.2 5,0.4 5,0.6 C5.1,0.8 5.1,1 5,1.2 C4.9,1.4 4.7,1.5 4.5,1.5 Z M4.5,2 C4.7,2 4.9,2 5.1,2.1 C5.3,2.2 5.5,2.3 5.6,2.5 C5.8,2.7 5.9,2.9 5.9,3.1 C5.9,3.4 5.8,3.6 5.7,3.8 C5.5,4.1 5.3,4.3 5,4.4 C4.8,4.5 4.5,4.6 4.3,4.6 C4.1,4.6 3.9,4.5 3.7,4.4 C3.5,4.3 3.3,4.1 3.2,3.9 C3,3.7 3,3.4 3,3.2 C3,2.9 3.1,2.7 3.3,2.5 C3.5,2.3 3.8,2.1 4,2 C4.2,2 4.3,2 4.5,2 Z"
                    fill="#000000"
                />
                <path
                    d="M8,2 L8.5,2 C8.7,2 8.9,2.1 9,2.2 C9.1,2.3 9.2,2.5 9.2,2.7 C9.2,2.9 9.1,3 9,3.1 C8.9,3.2 8.7,3.3 8.5,3.3 L8,3.3 L8,4.5 L7.5,4.5 L7.5,2 L8,2 Z M8,2.5 L8,2.8 L8.4,2.8 C8.5,2.8 8.6,2.8 8.7,2.7 C8.7,2.7 8.8,2.6 8.8,2.6 C8.8,2.5 8.7,2.5 8.7,2.4 C8.6,2.4 8.5,2.4 8.4,2.4 L8,2.4 L8,2.5 Z"
                    fill="#000000"
                />
                <path
                    d="M10.5,2 C10.8,2 11,2 11.2,2.1 C11.4,2.2 11.5,2.3 11.6,2.5 C11.7,2.7 11.8,2.9 11.8,3.2 C11.8,3.5 11.7,3.7 11.6,3.9 C11.5,4.1 11.4,4.2 11.2,4.3 C11,4.4 10.8,4.5 10.5,4.5 L9.8,4.5 L9.8,2 L10.5,2 Z M10.5,4 C10.7,4 10.9,3.9 11,3.8 C11.1,3.7 11.2,3.5 11.2,3.2 C11.2,3 11.1,2.8 11,2.7 C10.9,2.6 10.7,2.5 10.5,2.5 L10.3,2.5 L10.3,4 L10.5,4 Z"
                    fill="#000000"
                />
                <text
                    x="13"
                    y="4"
                    fontFamily="Arial, sans-serif"
                    fontSize="3.5"
                    fill="#000000"
                    fontWeight="normal"
                >
                    Pay
                </text>
            </g>
        </g>
    </svg>);
};

const GooglePayIcon = ({width = "24", height = "24"}) => {
    return (<svg
        width={`${width}px`}
        height={`${height}px`}
        viewBox="0 0 24 24"
        version="1.1"
    >
        <g
            id="googlepay-icon"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <rect
                x="0"
                y="4"
                width="24"
                height="16"
                rx="2"
                stroke="#000000"
                strokeWidth="1"
                fill="white"
            />
            <g transform="translate(2, 8)">
                <path
                    d="M4,1.5 C4.8,1.5 5.5,1.8 6,2.3 C6.5,2.8 6.8,3.5 6.8,4.2 C6.8,5 6.5,5.6 6,6.1 C5.5,6.6 4.8,6.9 4,6.9 C3.2,6.9 2.5,6.6 2,6.1 C1.5,5.6 1.2,5 1.2,4.2 C1.2,3.5 1.5,2.8 2,2.3 C2.5,1.8 3.2,1.5 4,1.5 Z M4,2.2 C3.4,2.2 2.9,2.4 2.5,2.8 C2.1,3.2 1.9,3.7 1.9,4.2 C1.9,4.8 2.1,5.3 2.5,5.7 C2.9,6.1 3.4,6.3 4,6.3 C4.6,6.3 5.1,6.1 5.5,5.7 L5.5,5.7 L5.5,5 L4.2,5 L4.2,4.4 L6.1,4.4 L6.1,5.9 C5.7,6.4 5.2,6.7 4.6,6.8 C4.4,6.9 4.2,6.9 4,6.9 C3.2,6.9 2.5,6.6 2,6.1 C1.5,5.6 1.2,5 1.2,4.2 C1.2,3.5 1.5,2.8 2,2.3 C2.5,1.8 3.2,1.5 4,1.5 C4.5,1.5 5,1.7 5.4,2 L5.4,2 L4.9,2.5 C4.6,2.3 4.3,2.2 4,2.2 Z"
                    fill="#5F6368"
                />
                <path
                    d="M8.5,2 L9.2,2 L9.2,4.5 L11,4.5 L11,5 L8.5,5 L8.5,2 Z"
                    fill="#5F6368"
                />
                <text
                    x="12"
                    y="4.5"
                    fontFamily="Arial, sans-serif"
                    fontSize="3.5"
                    fill="#5F6368"
                    fontWeight="normal"
                >
                    Pay
                </text>
            </g>
        </g>
    </svg>);
};

const ReconcileIcon = ({width = "24", height = "24", color}) => {
    return (
        <svg
            width={`${width}px`}
            height={`${height}px`}
            viewBox="0 0 512 512"
            fill={color ? color : "#6e86c4"}
        >
            {/* Receipt with zigzag top */}
            <path d="M 96 32 L 96 64 L 128 48 L 160 64 L 192 48 L 224 64 L 256 48 L 288 64 L 320 48 L 352 64 L 384 48 L 416 64 L 416 32 Z"/>
            <path d="M 96 64 L 96 480 L 416 480 L 416 64 L 384 48 L 352 64 L 320 48 L 288 64 L 256 48 L 224 64 L 192 48 L 160 64 L 128 48 L 96 64 Z M 128 96 L 384 96 L 384 448 L 128 448 L 128 96 Z"/>

            {/* Dollar sign */}
            <path d="M 240 160 L 240 180 C 225 185 215 200 215 218 C 215 240 230 252 250 258 C 265 263 272 268 272 280 C 272 290 265 296 252 296 C 240 296 232 288 228 278 L 208 286 C 214 303 228 315 240 320 L 240 340 L 260 340 L 260 320 C 275 315 285 300 285 282 C 285 260 270 248 250 242 C 235 237 228 232 228 220 C 228 210 235 204 248 204 C 260 204 268 212 272 222 L 292 214 C 286 197 272 185 260 180 L 260 160 L 240 160 Z"/>

            {/* Lines on receipt */}
            <path d="M 160 360 L 290 360 L 290 372 L 160 372 Z"/>
            <path d="M 160 388 L 330 388 L 330 400 L 160 400 Z"/>

            {/* Magnifying glass with checkmark */}
            <ellipse cx="420" cy="360" rx="70" ry="70" fill="none" stroke={color ? color : "#6e86c4"} strokeWidth="16"/>
            <ellipse cx="420" cy="360" rx="55" ry="55" fill="none" stroke={color ? color : "#6e86c4"} strokeWidth="12"/>
            <path d="M 468 408 L 500 440 L 512 428 L 480 396 Z" strokeWidth="8" stroke={color ? color : "#6e86c4"}/>

            {/* Checkmark inside magnifying glass */}
            <path d="M 400 360 L 412 372 L 440 344" fill="none" stroke={color ? color : "#6e86c4"} strokeWidth="10" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
};


export {
    ReadOnlyIcon,
    PrinterIcon,
    EditIcon,
    SendIcon,
    SettingSystemIcon,
    DigitalPen,
    CrossIcon,
    HistoryIcon,
    HomeIcon,
    RefreshIcon,
    HorizontalArrow,
    AdminSettingIcon,
    DownArrowIcon,
    TransactionReportIcon,
    HhaCardIcon,
    CreditCardIcon,
    DebitCardIcon,
    ECheckIcon,
    DownArrow,
    IntakeFormIcon,
    MousePointerIcon,
    AddCardIcon,
    SwipeCardIcon,
    PeopleIcon,
    PersonIcon,
    DollarSignIcon,
    TrashCanIcon,
    SignOnline,
    NewMessageIcon,
    CheckBoxIcon,
    ProfileIcon,
    FormIcon,
    ShuffleEditIcon,
    ApplePayIcon,
    GooglePayIcon,
    ReconcileIcon,
};
